import React from "react";
import ReactDOM from 'react-dom/client';
import { useNavigate, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import './LandingPage.css';
import { useEffect, useState, useRef, useMemo, useCallback } from 'react'
//import Amplify, { Auth, Hub, Storage, API } from 'aws-amplify';
import * as Auth from 'aws-amplify/auth';
import { get } from '@aws-amplify/api';
import { AgGridReact} from "ag-grid-react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import AppLayout from './components/AppLayout';
//import 'ag-grid-enterprise';
import { ModuleRegistry } from '@ag-grid-community/core';
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import "react-datepicker/dist/react-datepicker.css";
import {
  Button,
  Flex,
  Heading,
  Text,
  TextField,
  View,
  withAuthenticator,
} from "@aws-amplify/ui-react";
import { type } from "@testing-library/user-event/dist/type";

ModuleRegistry.registerModules([ExcelExportModule]);

const axios = require('axios');

const myAPI="mktappapi";
let path = '/strategy';

const MyPortfolioIronCondor = ({ signOut }) => {

  console.log("Executing MyPortfolioIronCondor");
  const navigate = useNavigate();

  let numberOfChecked=useRef(0);
  let deleteIds=useRef([]);

  //const [email, setEmail]=useState()
  let email=useRef();
  const [days, setDays]=useState();
  const [forceRender, setForceRender]=useState(false);
  const [daysOffset, setDaysOffset]=useState();
  const [minInterest, setMinInyerest]=useState();
  const [maxInterest, setMaxInterest]=useState();
  const [settingsStr, setSettingsStr]=useState({"days":"30","daysOffset":"10","minInterest":"0.7","maxInterest":"1.5"});
  const [data,setData]=useState();
  const [counter, setCounter]=useState(0);
  const [error,setError]=useState('');
  const [hide, setHide]=useState("hidden");
  const [submitted, setSubmitted]=useState(false);
  const [stocks, setStocks]=useState({});
  let calledGetMyTransactions = useRef(false);
  let [isEditing, setIsEditing] = useState(false);
  let selectedRecord = useRef();
  let deleteRecIds = useRef([]);
  let [recsWereDeleted, setRecsWereDeleted] = useState(-1);
  let [displayMainMessage, setDisplayMainMessage] = useState("");
  let unrealizedProfit = useRef(0);
  let realizedProfit = useRef(0);
  let investedInMarket = useRef(0);
  let asOfDateTime = useRef();

  let apiCalled=useRef(0);

  const getUserInfo = async () => {
    try {
      await Auth.fetchAuthSession();
      // Retrieve the user's email address
      const user = await Auth.fetchUserAttributes();
      console.log("getUserInfo : email = " + JSON.stringify(user.email));
      email.current = await user.email;
      return "done";
    } catch (error) {
      console.log("Error in getUserInfo: ", error);
      return "error";
    }
  };
  
  let initString="";

  //const [analysis, setAnalysis]=useState([]);
  let analysis=useRef([]);

  let recLst=[];
  let indRecLst=0;

  let maxChg="";
  let avgChg="";
  let wAvgChg="";
  let maxChgArrStr=[];
  let maxChgArrNum=[];
  let chgPercentCnt=0;
  let sumChgPercent=0;
  let wSumChgPercent=0;
  let wSum=0;
  let cnt33=0;
  let cnt66=0;
  let cnt100=0;
  let profitResponse="";
  let daysNowToExp = useRef();
  const location = useLocation();
  const icType = location.state?.icType || "DEFAULT";
  
  async function getMyTransactions(email) {
    await console.log("Executing getMyTransactions");
    await console.log("getMyTransactions : email = "+email);
    await console.log("getMyTransactions : icType = " + icType);

    calledGetMyTransactions.current = true;
    path = '/getIronCondorTransactions';

    var passApiStr=path + "/" + email + "/" + icType;
    await console.log("passApiStr = "+passApiStr);
    //await get(myAPI, passApistr)
    const response = await get({
      apiName: myAPI,
      path: passApiStr,
    }).response;
    let resp = await response.body.json();
    await Promise.resolve(resp)
       .then(async () => {
         await console.log("getMyTransactions : response = " + JSON.stringify(resp));
         await console.log(resp);
         var count = Object.keys(resp).length;
         analysis.current=[];
         await console.log("getMyTransactions : count = "+ count);
         if (count>0){
          analysis.current=[];
          for (var i=0; i<count; i++) {
            if (i==1){
              for (var j=0; j<resp[i].length; j++) {
                var keys = Object.keys(resp[i]);
                //await console.log(keys[j] + " = " + response[i][j]);
                if (resp[i][j]=="null") {
                  resp[i][j]=0;
                }
              }
            }
            await console.log ("response[" + i + "] = " +JSON.stringify(resp[i]));
            let responseObj = JSON.parse(resp[i]);
            await console.log("getMyTransactions : responseObj = ", responseObj);
            
            analysis.current.push(responseObj);
          }
          await console.log("getMyTransactions : analysis.length = " +analysis.current.length);
         }
       })
      .then(() => {
        loadRowData();
      })
       .catch(error => {
         console.log(error)
       })
  }

  
let rowdata=[];
const [rowDataState,setRowDataSate]=useState([]);

  function loadRowData() {
    console.log ("Executing loadRowData");
    console.log ("loadRowData : analysis = "+ JSON.stringify(analysis.current));
    var buyWriteCost, premium, maxProfit, breakEven, daysNowToExp, optionPrice, pnl, pnlProfit;
    if (typeof(analysis.current)!='undefined') {
      var key=0;
      //var count = Object.keys(analysis).length;
      var count=analysis.current.length;
      console.log ("loadRowData : analysis length= "+count);
      var rank=0;

      if (count === 0) {
        rowdata = [];
        setRowDataSate(rowdata);
      }

      for (key=0; key<count; key++) {
        let recObj = analysis.current[key].toString().trim();
        //recObj = "{'Security' : 'SPY', 'Sell Call Strike' : 545.00, 'Buy Call Strike' : 524.00, 'Buy Put Strike' : 519.00, 'Sell Put Strike' : 495.00, 'Position' : 'LONG', 'Expiration' : '2024-04-26', 'Last Sale' : 521.21, 'Sell Call Open Quote' : 0.80, 'Sell Call Open Cost' : 160.00, 'Buy Call Open Quote' : 7.02, 'Buy Call Open Cost' : -1404.00, 'Buy Put Open Quote' : 5.27, 'Buy Put Open Cost' : -1054.00, 'Sell Put Open Quote' : 1.17, 'Sell Put Open Cost' : 234.00, 'Net Amount' : -10.32, 'Max Loss' : -2064.00, 'Commission Fee' : 5.20, 'Upper': 5.00, 'Lower': 0.50, 'Days': 30, 'Contracts': 2, 'Open Trade Date': '2024-03-24', 'Close Trade Date': '', 'Desired Profit Percent': 2.00, 'Open Cost': -2069.20, 'Buy Call Close Quote': 0.83, 'Buy Call Close Cost': -166, 'Sell Call Close Quote': 6.96, 'Sell Call Close Cost': 1392, 'Buy Put Close Quote': 1.2, 'Buy Put Close Cost': -240, 'Sell Put Close Quote': 5.21, 'Sell Put Close Cost': 1042, 'Close Cost': 2028, 'Profit Loss Dollars': -41.20, 'Profit Loss Percents': -0.02 }"
        recObj = recObj.replace(/'/g, '"');
        //recObj = recObj.replace("LONG", "\"LONG\"");
        //recObj = recObj.replace("SHORT", "\"SHORT\"");
        recObj = recObj.toString().replace("{ ", "{");
        recObj = recObj.toString().replace(" }", "}");
        console.log("loadRowData : recObj before parse = " + recObj);
        console.log("loadRowData : recObj before parse type = " + typeof(recObj));
        recObj = recObj.replace(/NaN/g, '0');
        recObj = recObj.replace(/ -Infinity/g, 0);
        recObj = JSON.parse(recObj);
        console.log("loadRowData : recObj after parse type = " + typeof(recObj));
        console.log("loadRowData : recObj = ", recObj);
        let closeTradeDate = "";
        if (recObj["Close Trade Date"].toString().trim().toLowerCase() === "null") {
          closeTradeDate = "";
        } else {
          closeTradeDate = recObj["Close Trade Date"];
        }
        if (recObj["Desired Profit Percent"] === "") {
          recObj["Desired Profit Percent"] = 0.0;
        }
        let buyCallStrikeUpdate = true;
        if (recObj["Buy Call Strike Update"] === "true") {
          buyCallStrikeUpdate = false;
        };
        let sellCallStrikeUpdate = true;
        if (recObj["Sell Call Strike Update"] === "true") {
          sellCallStrikeUpdate = false;
        };
        let sellPutStrikeUpdate = true;
        if (recObj["Sell Put Strike Update"] === "true") {
          sellPutStrikeUpdate = false;
        };
        let buyPutStrikeUpdate = true;
        if (recObj["Buy Put Strike Update"] === "true") {
          buyPutStrikeUpdate = false;
        };
        let paperTrade = true;
        if (recObj["Paper Trade"] === "false") {
          paperTrade = false;
        }
        let includeCommissionFee = true;
        if (recObj["Include Commission Fee"] === "false") {
          includeCommissionFee = false;
        }
        let desiredNetAmount = ((-1) * parseFloat(recObj["Net Amount"]) + (-1) * parseFloat(recObj["Net Amount"]) * parseFloat(recObj["Desired Profit Percent"]) / 100).toFixed(2);

        let gammaBuyCallStrike = parseFloat(parseFloat(recObj["Gamma Buy Call Strike"]).toFixed(2)) || 0;
        let gammaSellCallStrike = parseFloat(parseFloat(recObj["Gamma Sell Call Strike"]).toFixed(2)) || 0;
        let gammaBuyPutStrike = parseFloat(parseFloat(recObj["Gamma Buy Put Strike"]).toFixed(2)) || 0;
        let gammaSellPutStrike = parseFloat(parseFloat(recObj["Gamma Sell Put Strike"]).toFixed(2)) || 0;
        let vegaBuyCallStrike = parseFloat(parseFloat(recObj["Vega Buy Call Strike"]).toFixed(2)) || 0;
        let vegaSellCallStrike = parseFloat(parseFloat(recObj["Vega Sell Call Strike"]).toFixed(2)) || 0;
        let vegaBuyPutStrike = parseFloat(parseFloat(recObj["Vega Buy Put Strike"]).toFixed(2)) || 0;
        let vegaSellPutStrike = parseFloat(parseFloat(recObj["Vega Sell Put Strike"]).toFixed(2)) || 0;
        let thetaBuyCallStrike = parseFloat(parseFloat(recObj["Theta Buy Call Strike"]).toFixed(2)) || 0;
        let thetaSellCallStrike = parseFloat(parseFloat(recObj["Theta Sell Call Strike"]).toFixed(2)) || 0;
        let thetaBuyPutStrike = parseFloat(parseFloat(recObj["Theta Buy Put Strike"]).toFixed(2)) || 0;
        let thetaSellPutStrike = parseFloat(parseFloat(recObj["Theta Sell Put Strike"]).toFixed(2)) || 0;
        let deltaBuyCallStrike = parseFloat(parseFloat(recObj["Delta Buy Call Strike"]).toFixed(2)) || 0;
        let deltaSellCallStrike = parseFloat(parseFloat(recObj["Delta Sell Call Strike"]).toFixed(2)) || 0;
        let deltaBuyPutStrike = parseFloat(parseFloat(recObj["Delta Buy Put Strike"]).toFixed(2)) || 0;
        let deltaSellPutStrike = parseFloat(parseFloat(recObj["Delta Sell Put Strike"]).toFixed(2)) || 0;
        let netDelta = (deltaBuyCallStrike + deltaBuyPutStrike - deltaSellCallStrike - deltaSellPutStrike).toFixed(2);
        let netTheta = (thetaBuyCallStrike + thetaBuyPutStrike - thetaSellCallStrike - thetaSellPutStrike).toFixed(2);
        let netGamma = (gammaBuyCallStrike + gammaBuyPutStrike - gammaSellCallStrike - gammaSellPutStrike).toFixed(2);
        let netVega = (vegaBuyCallStrike + vegaBuyPutStrike - vegaSellCallStrike - vegaSellPutStrike).toFixed(2);

        let gammaBuyCallStrikeCurrent = parseFloat(parseFloat(recObj["Gamma Buy Call Strike Current"]).toFixed(2)) || 0;
        let gammaSellCallStrikeCurrent = parseFloat(parseFloat(recObj["Gamma Sell Call Strike Current"]).toFixed(2)) || 0;
        let gammaBuyPutStrikeCurrent = parseFloat(parseFloat(recObj["Gamma Buy Put Strike Current"]).toFixed(2)) || 0;
        let gammaSellPutStrikeCurrent = parseFloat(parseFloat(recObj["Gamma Sell Put Strike Current"]).toFixed(2)) || 0;
        let vegaBuyCallStrikeCurrent = parseFloat(parseFloat(recObj["Vega Buy Call Strike Current"]).toFixed(2)) || 0;
        let vegaSellCallStrikeCurrent = parseFloat(parseFloat(recObj["Vega Sell Call Strike Current"]).toFixed(2)) || 0;
        let vegaBuyPutStrikeCurrent = parseFloat(parseFloat(recObj["Vega Buy Put Strike Current"]).toFixed(2)) || 0;
        let vegaSellPutStrikeCurrent = parseFloat(parseFloat(recObj["Vega Sell Put Strike Current"]).toFixed(2)) || 0;
        let thetaBuyCallStrikeCurrent = parseFloat(parseFloat(recObj["Theta Buy Call Strike Current"]).toFixed(2)) || 0;
        let thetaSellCallStrikeCurrent = parseFloat(parseFloat(recObj["Theta Sell Call Strike Current"]).toFixed(2)) || 0;
        let thetaBuyPutStrikeCurrent = parseFloat(parseFloat(recObj["Theta Buy Put Strike Current"]).toFixed(2)) || 0;
        let thetaSellPutStrikeCurrent = parseFloat(parseFloat(recObj["Theta Sell Put Strike Current"]).toFixed(2)) || 0;
        let deltaBuyCallStrikeCurrent = parseFloat(parseFloat(recObj["Delta Buy Call Strike Current"]).toFixed(2)) || 0;
        let deltaSellCallStrikeCurrent = parseFloat(parseFloat(recObj["Delta Sell Call Strike Current"]).toFixed(2)) || 0;
        let deltaBuyPutStrikeCurrent = parseFloat(parseFloat(recObj["Delta Buy Put Strike Current"]).toFixed(2)) || 0;
        let deltaSellPutStrikeCurrent = parseFloat(parseFloat(recObj["Delta Sell Put Strike Current"]).toFixed(2)) || 0;
        let maxGain = parseFloat(parseFloat(recObj["Max Gain"]).toFixed(2)) || 0;
        let vixLastSale = parseFloat(parseFloat(recObj["VIX Last Sale"]).toFixed(2)) || 0;
        let vixChange = parseFloat(parseFloat(recObj["VIX Change"]).toFixed(2)) || 0;
        let netDeltaCurrent = (deltaBuyCallStrikeCurrent + deltaBuyPutStrikeCurrent - deltaSellCallStrikeCurrent - deltaSellPutStrikeCurrent).toFixed(2);
        let netThetaCurrent = (thetaBuyCallStrikeCurrent + thetaBuyPutStrikeCurrent - thetaSellCallStrikeCurrent - thetaSellPutStrikeCurrent).toFixed(2);
        let netGammaCurrent = (gammaBuyCallStrikeCurrent + gammaBuyPutStrikeCurrent - gammaSellCallStrikeCurrent - gammaSellPutStrikeCurrent).toFixed(2);
        let netVegaCurrent = (vegaBuyCallStrikeCurrent + vegaBuyPutStrikeCurrent - vegaSellCallStrikeCurrent - vegaSellPutStrikeCurrent).toFixed(2);

        rowdata[key]={
          email: email.current,
          id: recObj["Id"],
          security: recObj["Security"],
          exp: recObj["Expiration"],
          contracts: parseInt(recObj["Contracts"]),
          sellCallStrike: parseFloat(recObj["Sell Call Strike"]).toFixed(2),
          buyCallStrike: parseFloat(recObj["Buy Call Strike"]).toFixed(2),
          buyPutStrike: parseFloat(recObj["Buy Put Strike"]).toFixed(2),
          sellPutStrike: parseFloat(recObj["Sell Put Strike"]).toFixed(2),
          openCost: parseFloat(recObj["Open Cost"]).toFixed(2),
          closeCost: parseFloat(recObj["Close Cost"]).toFixed(2),
          profitLossDollars: parseFloat(recObj["Profit Loss Dollars"]).toFixed(2),
          profitLossPercent: parseFloat(recObj["Profit Loss Percents"]).toFixed(2),
          position: recObj.Position,
          lastSale: parseFloat(recObj["Last Sale"]).toFixed(2),
          sellCallOpenQuote: parseFloat(recObj["Sell Call Open Quote"]).toFixed(2),
          sellCallOpenCost: parseFloat(recObj["Sell Call Open Cost"]).toFixed(2),
          buyCallOpenQuote: parseFloat(recObj["Buy Call Open Quote"]).toFixed(2),
          buyCallOpenCost: parseFloat(recObj["Buy Call Open Cost"]).toFixed(2),
          buyPutOpenCost: parseFloat(recObj["Buy Put Open Cost"]).toFixed(2),
          buyPutOpenQuote: parseFloat(recObj["Buy Put Open Quote"]).toFixed(2),
          sellPutOpenQuote: parseFloat(recObj["Sell Put Open Quote"]).toFixed(2),
          sellPutOpenCost: parseFloat(recObj["Sell Put Open Cost"]).toFixed(2),
          netAmount: parseFloat(recObj["Net Amount"]).toFixed(2),
          maxLoss: parseFloat(recObj["Max Loss"]).toFixed(2),
          commissionFee: parseFloat(recObj["Commission Fee"]).toFixed(2),
          upper: parseFloat(recObj["Upper"]).toFixed(2),
          lower: parseFloat(recObj["Lower"]).toFixed(2),
          days: parseInt(recObj["Days"]),
          openTradeDate: recObj["Open Trade Date"],
          closeTradeDate: closeTradeDate,
          desiredProfitPercent: parseFloat(recObj["Desired Profit Percent"]).toFixed(2),
          sellCallCloseQuote: parseFloat(recObj["Sell Call Close Quote"]).toFixed(2),
          sellCallCloseCost: parseFloat(recObj["Sell Call Close Cost"]).toFixed(2),
          buyCallCloseQuote: parseFloat(recObj["Buy Call Close Quote"]).toFixed(2),
          buyCallCloseCost: parseFloat(recObj["Buy Call Close Cost"]).toFixed(2),
          buyPutCloseCost: parseFloat(recObj["Buy Put Close Cost"]).toFixed(2),
          buyPutCloseQuote: parseFloat(recObj["Buy Put Close Quote"]).toFixed(2),
          sellPutCloseQuote: parseFloat(recObj["Sell Put Close Quote"]).toFixed(2),
          sellPutCloseCost: parseFloat(recObj["Sell Put Close Cost"]).toFixed(2),
          lastSaleClose: parseFloat(recObj["Last Sale Close"]).toFixed(2),
          netAmountClose: parseFloat(recObj["Net Amount Close"]).toFixed(2),
          desiredNetAmount: desiredNetAmount,
          buyCallStrikeUpdate: buyCallStrikeUpdate,
          sellCallStrikeUpdate: sellCallStrikeUpdate,
          sellPutStrikeUpdate: sellPutStrikeUpdate,
          buyPutStrikeUpdate: buyPutStrikeUpdate,
          paperTrade: paperTrade,
          includeCommissionFee: includeCommissionFee,
          upperBreakeven: parseFloat(recObj["Upper Breakeven"]).toFixed(2),
          lowerBreakeven: parseFloat(recObj["Lower Breakeven"]).toFixed(2),
          /*vegaSellCallStrike: parseFloat(recObj["Vega Sell Call Strike"]).toFixed(2),
          vegaBuyCallStrike: parseFloat(recObj["Vega Buy Call Strike"]).toFixed(2),
          vegaBuyPutStrike: parseFloat(recObj["Vega Buy Put Strike"]).toFixed(2),
          vegaSellPutStrike: parseFloat(recObj["Vega Sell Put Strike"]).toFixed(2),*/
          gammaSellCallStrike: gammaSellCallStrike,
          gammaBuyCallStrike: gammaBuyCallStrike,
          gammaBuyPutStrike: gammaBuyPutStrike,
          gammaSellPutStrike: gammaSellPutStrike,
          vegaSellCallStrike: vegaSellCallStrike,
          vegaBuyCallStrike: vegaBuyCallStrike,
          vegaBuyPutStrike: vegaBuyPutStrike,
          vegaSellPutStrike: vegaSellPutStrike,
          thetaSellCallStrike: thetaSellCallStrike,
          thetaBuyCallStrike: thetaBuyCallStrike,
          thetaBuyPutStrike: thetaBuyPutStrike,
          thetaSellPutStrike: thetaSellPutStrike,
          deltaSellCallStrike: deltaSellCallStrike,
          deltaBuyCallStrike: deltaBuyCallStrike,
          deltaBuyPutStrike: deltaBuyPutStrike,
          deltaSellPutStrike: deltaSellPutStrike,
          netDelta: netDelta,
          netTheta: netTheta,
          netGamma: netGamma,
          netVega: netVega,
          notes: recObj.Notes,
          gammaSellCallStrikeCurrent: gammaSellCallStrikeCurrent,
          gammaBuyCallStrikeCurrent: gammaBuyCallStrikeCurrent,
          gammaBuyPutStrikeCurrent: gammaBuyPutStrikeCurrent,
          gammaSellPutStrikeCurrent: gammaSellPutStrikeCurrent,
          vegaSellCallStrikeCurrent: vegaSellCallStrikeCurrent,
          vegaBuyCallStrikeCurrent: vegaBuyCallStrikeCurrent,
          vegaBuyPutStrikeCurrent: vegaBuyPutStrikeCurrent,
          vegaSellPutStrikeCurrent: vegaSellPutStrikeCurrent,
          thetaSellCallStrikeCurrent: thetaSellCallStrikeCurrent,
          thetaBuyCallStrikeCurrent: thetaBuyCallStrikeCurrent,
          thetaBuyPutStrikeCurrent: thetaBuyPutStrikeCurrent,
          thetaSellPutStrikeCurrent: thetaSellPutStrikeCurrent,
          deltaSellCallStrikeCurrent: deltaSellCallStrikeCurrent,
          deltaBuyCallStrikeCurrent: deltaBuyCallStrikeCurrent,
          deltaBuyPutStrikeCurrent: deltaBuyPutStrikeCurrent,
          deltaSellPutStrikeCurrent: deltaSellPutStrikeCurrent,
          netDeltaCurrent: netDeltaCurrent,
          netThetaCurrent: netThetaCurrent,
          netGammaCurrent: netGammaCurrent,
          netVegaCurrent: netVegaCurrent,
          vixLastSale: vixLastSale,
          vixChange: vixChange,
          maxGain: maxGain,
          mktDirection: recObj["MKT Direction"]
        }
        let rowDataCount = Object.keys(rowdata[key]).length;
        console.log("loadRowData : rowDataCount = " + rowDataCount);
      }
      
      console.log("loadRowData : typeof rowDataState = "+typeof(rowDataState));
      console.log("loadRowData : length rowDataState = "+rowDataState.length);
      console.log("loadRowData : count = "+count);
      console.log("loadRowData : rowDataState.length = "+rowDataState.length);;
      let realProfit = 0;
      let unRealProfit = 0;
      let invest = 0;
      for (let rowInd = 0; rowInd < rowdata.length; rowInd++) {
        console.log ("loadRowData : closeTradeDate = " + rowdata[rowInd].closeTradeDate + "\trowdata[rowInd].closeTradeDate.length = " + rowdata[rowInd].closeTradeDate.length + "\tpaperTrade = " + rowdata[rowInd].paperTrade);
        if ((isExpired(rowdata[rowInd].exp) || rowdata[rowInd].closeTradeDate.length > 0) && !rowdata[rowInd].paperTrade) {
          realProfit = realProfit + parseFloat(rowdata[rowInd].profitLossDollars);
          console.log ("loadRowData : rowdata[rowInd].profitLossDollars = " + rowdata[rowInd].profitLossDollars);
          console.log ("loadRowData : realProfit = " + realProfit);
        } else if (!rowdata[rowInd].paperTrade){
          unRealProfit = unRealProfit + parseFloat(rowdata[rowInd].profitLossDollars);

          invest = invest + parseFloat(rowdata[rowInd].openCost);
          
        }
      }
      if (parseFloat(invest) < 0) {
        invest = parseFloat(invest) * (-1);
      }
      /*unrealizedProfit.current = unRealProfit.toLocaleString('en-US');
      realizedProfit.current = realProfit.toLocaleString('en-US');
      investedInMarket.current = invest.toLocaleString('en-US');*/

      unrealizedProfit.current = unRealProfit.toString();
      realizedProfit.current = realProfit.toString();;
      investedInMarket.current = invest.toString();;

      if (count!=0) {
        setRowDataSate(rowdata);
        console.log("loadRowData : rowdata = ", rowdata);
      }
      
    }
  }

  const rowClassRules = {

    // row style function
    'goodOption': function(params) {
      console.log ("Executing goodOption");
      console.log ("goodOption : params = ", params);
      var expStr=params.data["exp"];
      var dtExp=new Date(expStr).toUTCString().toString();
      let dateObj = new Date(dtExp);
      let secondsExp = dateObj.getTime() / 1000;
      var dtNow=new Date();
      dateObj = new Date(dtNow);
      let secondsNow = dateObj.getTime() / 1000;
      console.log("goodOption : secondsNow = " + secondsNow + "\tsecondsExp = " + secondsExp);
      console.log("goodOption : dtNow = " + dtNow + "\tdtExp = " + dtExp);
      dtNow.setHours(0, 0, 0, 0);
      var expDays=(Date.parse(dtExp)-Date.parse(dtNow))/1000/60/60/24;
      expDays=Math.round(expDays);
      console.log("rowClassRules : goodOption : daysNowToExp = "+expDays  + "\tsymbol = " + params.data["symbol"]);
    
      return parseFloat(params.data.profitLossDollars) > 0.00 && expDays >= 0 && params.data.closeTradeDate.length === 0;
    },
    'goodOptionClosed': function(params) {
      console.log ("Executing goodOption");
      console.log ("goodOption : params = ", params);
      var expStr=params.data["exp"];
      var dtExp=new Date(expStr).toUTCString().toString();
      let dateObj = new Date(dtExp);
      let secondsExp = dateObj.getTime() / 1000;
      var dtNow=new Date();
      dateObj = new Date(dtNow);
      let secondsNow = dateObj.getTime() / 1000;
      console.log("goodOption : secondsNow = " + secondsNow + "\tsecondsExp = " + secondsExp);
      console.log("goodOption : dtNow = " + dtNow + "\tdtExp = " + dtExp);
      dtNow.setHours(0, 0, 0, 0);
      var expDays=(Date.parse(dtExp)-Date.parse(dtNow))/1000/60/60/24;
      expDays=Math.round(expDays);
      console.log("rowClassRules : goodOption : daysNowToExp = "+expDays  + "\tsymbol = " + params.data["symbol"]);
    
      return parseFloat(params.data.profitLossDollars) > 0.00 && (expDays < 0 || params.data.closeTradeDate.length > 0);
    },
    /*'mediumOption': function (params) {
      console.log ("Executing medium");
      console.log("mediumOption : params = ", params);
      var expStr=params.data["exp"];
      var dtExp=new Date(expStr).toUTCString().toString();
      let dateObj = new Date(dtExp);
      let secondsExp = dateObj.getTime() / 1000;
      var dtNow=new Date();
      dateObj = new Date(dtNow);
      let secondsNow = dateObj.getTime() / 1000;
      console.log("medium : secondsNow = " + secondsNow + "\tsecondsExp = " + secondsExp);
      dtNow.setHours(0, 0, 0, 0);
      var expDays=(Date.parse(dtExp)-Date.parse(dtNow))/1000/60/60/24;
      expDays=Math.round(expDays);
      console.log("rowClassRules : mediumOption : daysNowToExp = "+expDays + "\tsymbol = " + params.data["symbol"]);
      
      return parseFloat(params.data.profitLossDollars) <= 0  && expDays >= 0 && params.data.closeTradeDate.length === 0 && (parseFloat(params.data.lastSaleClose) > parseFloat(params.data.buyCallStrike) || parseFloat(params.data.lastSaleClose) < parseFloat(params.data.buyPutStrike));
    },*/
    // row style expression
    'badOptionPortfolio': function (params) {
      console.log ("Executing badOptionPortfolio");
      console.log("badOption : params = ", params);
      var expStr=params.data["exp"];
      var dtExp=new Date(expStr).toUTCString().toString();
      let dateObj = new Date(dtExp);
      let secondsExp = dateObj.getTime() / 1000;
      var dtNow=new Date();
      dateObj = new Date(dtNow);
      let secondsNow = dateObj.getTime() / 1000;
      console.log("badOption : secondsNow = " + secondsNow + "\tsecondsExp = " + secondsExp);
      dtNow.setHours(0, 0, 0, 0);
      var expDays=(Date.parse(dtExp)-Date.parse(dtNow))/1000/60/60/24;
      expDays=Math.round(expDays);
      console.log("rowClassRules : mbadOptionPortfolio : daysNowToExp = "+expDays + "\tsymbol = " + params.data["symbol"]);
      
      return parseFloat(params.data.profitLossDollars) < 0  && expDays >= 0 && params.data.closeTradeDate.length === 0 ;
    },
    'badOptionPortfolioClosed': function (params) {
      console.log ("Executing badOptionPortfolio");
      console.log("badOption : params = ", params);
      var expStr=params.data["exp"];
      var dtExp=new Date(expStr).toUTCString().toString();
      let dateObj = new Date(dtExp);
      let secondsExp = dateObj.getTime() / 1000;
      var dtNow=new Date();
      dateObj = new Date(dtNow);
      let secondsNow = dateObj.getTime() / 1000;
      console.log("badOption : secondsNow = " + secondsNow + "\tsecondsExp = " + secondsExp);
      dtNow.setHours(0, 0, 0, 0);
      var expDays=(Date.parse(dtExp)-Date.parse(dtNow))/1000/60/60/24;
      expDays=Math.round(expDays);
      console.log("rowClassRules : mbadOptionPortfolio : daysNowToExp = "+expDays + "\tsymbol = " + params.data["symbol"]);
      
      return parseFloat(params.data.profitLossDollars) < 0  && (expDays < 0 || params.data.closeTradeDate.length > 0);
    },
};

useEffect(()=>{
  console.log ("Executing useEffect");
  async function fetchData() {
    await console.log ("Executing useEffect : fetchData");
    await getUserInfo();
    await console.log ("useEffect : email.current = " + email.current);
    await console.log ("useEffect : calledGetMyTransactions.current = " + calledGetMyTransactions.current);
    if (typeof(email.current)!='undefined' && !calledGetMyTransactions.current) {
      await getMyTransactions(email.current);
    };
  };
  if (isEditing === false) {
    fetchData();
    const interval = setInterval(() => {
      calledGetMyTransactions.current = false;
      fetchData();
      setCounter(prevCounter => prevCounter + 1); // Update directly inside
    }, 5 * 60 * 1000); 

    return () => clearInterval(interval);
  }
},[submitted, isEditing, recsWereDeleted, counter])

// Reset edit mode when navigating to a different portfolio or clicking same portfolio button
useEffect(() => {
  if (isEditing) {
    setIsEditing(false);
  }
}, [location.pathname, location.key]);

const gridRef = useRef();

let gridApi = useCallback(() => {
  console.log ("Executing gridApi");
  if (!gridRef.current) {
    console.log("!gridRef.current");
    return;
  }

  console.log("!gridRef.current");
  return gridRef.current.gridApi;
}, [gridRef]);

const setCellValue = (rowIndex, columnField, value) => {
  console.log ("Executing setCellValue");
  gridApi().setDataValue(rowIndex, columnField, value);
};

function getFormattedDate(date) {
  console.log ("Executing getFormattedDate");
  console.log("getFormattedDate: received date = "+date);
  if (typeof(date)!='undefined') {
    if (date.toString().length>0){
      //console.log("getFormattedDate : received date = "+ date.toString());
      let year = date.getFullYear();
      let month = (1 + date.getMonth()).toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');
    
      console.log("getFormattedDate : returning date = "+ month + '/' + day + '/' + year);
    
      return month + '/' + day + '/' + year;
    } else {
      return "";
    }
  } else {
    return "";
  }
  
}

function formatCurrency(value, locale = 'en-US', currency = 'USD') {
  // Convert the string to a number first if it's not already
  const numberValue = parseFloat(value);

  // Format the number as currency
  return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
  }).format(numberValue);
}

let columns;
let strikeColumns; 

if (icType === "LONG") {
  strikeColumns = [
    {headerName: "Sell Call Strike", field: "sellCallStrike", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:130, editable: false, resizable:true, /*cellRenderer: row =>{
      if (typeof(row.data.exp) !== 'undefined') {
        if (isNaN(row.data.sellCallStrike)) {
          row.data.sellCallStrike=0;
          return row.data.sellCallStrike;
        } else {
            return row.data.sellCallStrike;
        }
      }
    },*/
      valueGetter: (params) => {
      // Ensure the value is a number, provide 0 as a fallback
          return parseFloat(params.data.sellCallStrike) || 0;
      },
      valueFormatter: (params) => {
          // Convert to string with two decimal places and append '%'
          return `${formatCurrency(params.value)}`;
      },
      cellStyle: (params) => {
        if (parseFloat(params.data.lastSaleClose) > parseFloat(params.data.sellCallStrike)) {
            return { fontWeight: '900' };  // Apply bold style if the condition is met
        } else {
            return null;  // Return null for default styling
        }
      },
      cellRenderer: (params) => {
          // Use value formatter in cell renderer for consistency
          return params.valueFormatted;
      }
    },
    {headerName: "Buy Call Strike", field: "buyCallStrike", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:130, editable: false, cellClass: 'bordered-cell', resizable:true, 
      valueGetter: (params) => {
      // Ensure the value is a number, provide 0 as a fallback
          return parseFloat(params.data.buyCallStrike) || 0;
      },
  
      valueFormatter: (params) => {
        // Assuming formatCurrency is a function that formats the number as a currency string
        return formatCurrency(params.value);
      },
      cellStyle: (params) => {
          if (parseFloat(params.data.lastSaleClose) > parseFloat(params.data.buyCallStrike)) {
              return { fontWeight: '900' };  // Apply bold style if the condition is met
          } else {
              return null;  // Return null for default styling
          }
      },
  
      cellRenderer: (params) => {
        // Use value formatter in cell renderer for consistency
        return params.valueFormatted;
      }
    },
    {headerName: "Buy Put Strike", field: "buyPutStrike", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:130, editable: false, cellClass: 'bordered-cell', resizable:true, 
      valueGetter: (params) => {
      // Ensure the value is a number, provide 0 as a fallback
          return parseFloat(params.data.buyPutStrike) || 0;
      },
      valueFormatter: (params) => {
          // Convert to string with two decimal places and append '%'
          return `${formatCurrency(params.value)}`;
      },
      cellStyle: (params) => {
        if (parseFloat(params.data.lastSaleClose) < parseFloat(params.data.buyPutStrike)) {
            return { fontWeight: 'bold' };  // Apply bold style if the condition is met
        } else {
            return null;  // Return null for default styling
        }
      },
      cellRenderer: (params) => {
          // Use value formatter in cell renderer for consistency
          return params.valueFormatted;
      }
    },
    {headerName: "Sell Put Strike", field: "sellPutStrike", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:130, editable: false, resizable:true, /*cellRenderer: row =>{
      if (typeof(row.data.exp) !== 'undefined') {
        if (isNaN(row.data.sellPutStrike)) {
          row.data.sellPutStrike=0;
          return row.data.sellPutStrike;
        } else {
            return row.data.sellPutStrike;
        }
      }
    },*/
      valueGetter: (params) => {
      // Ensure the value is a number, provide 0 as a fallback
          return parseFloat(params.data.sellPutStrike) || 0;
      },
      valueFormatter: (params) => {
          // Convert to string with two decimal places and append '%'
          return `${formatCurrency(params.value)}`;
      },
      cellStyle: (params) => {
        if (parseFloat(params.data.lastSaleClose) < parseFloat(params.data.sellPutStrike)) {
            return { fontWeight: 'bold' };  // Apply bold style if the condition is met
        } else {
            return null;  // Return null for default styling
        }
      },
      cellRenderer: (params) => {
          // Use value formatter in cell renderer for consistency
          return params.valueFormatted;
      }
    }
  ]
}

if (icType === "SHORT") {
  strikeColumns = [
    
    {headerName: "Buy Call Strike", field: "buyCallStrike", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:130, editable: false, cellClass: 'bordered-cell', resizable:true, 
      valueGetter: (params) => {
      // Ensure the value is a number, provide 0 as a fallback
          return parseFloat(params.data.buyCallStrike) || 0;
      },
  
      valueFormatter: (params) => {
        // Assuming formatCurrency is a function that formats the number as a currency string
        return formatCurrency(params.value);
      },
      cellStyle: (params) => {
          if (parseFloat(params.data.lastSaleClose) > parseFloat(params.data.buyCallStrike)) {
              return { fontWeight: '900' };  // Apply bold style if the condition is met
          } else {
              return null;  // Return null for default styling
          }
      },
  
      cellRenderer: (params) => {
        // Use value formatter in cell renderer for consistency
        return params.valueFormatted;
      }
    },
    {headerName: "Sell Call Strike", field: "sellCallStrike", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:130, editable: false, resizable:true, /*cellRenderer: row =>{
      if (typeof(row.data.exp) !== 'undefined') {
        if (isNaN(row.data.sellCallStrike)) {
          row.data.sellCallStrike=0;
          return row.data.sellCallStrike;
        } else {
            return row.data.sellCallStrike;
        }
      }
    },*/
      valueGetter: (params) => {
      // Ensure the value is a number, provide 0 as a fallback
          return parseFloat(params.data.sellCallStrike) || 0;
      },
      valueFormatter: (params) => {
          // Convert to string with two decimal places and append '%'
          return `${formatCurrency(params.value)}`;
      },
      cellStyle: (params) => {
        if (parseFloat(params.data.lastSaleClose) > parseFloat(params.data.sellCallStrike)) {
            return { fontWeight: '900' };  // Apply bold style if the condition is met
        } else {
            return null;  // Return null for default styling
        }
      },
      cellRenderer: (params) => {
          // Use value formatter in cell renderer for consistency
          return params.valueFormatted;
      }
    },
    
    {headerName: "Sell Put Strike", field: "sellPutStrike", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:130, editable: false, resizable:true, /*cellRenderer: row =>{
      if (typeof(row.data.exp) !== 'undefined') {
        if (isNaN(row.data.sellPutStrike)) {
          row.data.sellPutStrike=0;
          return row.data.sellPutStrike;
        } else {
            return row.data.sellPutStrike;
        }
      }
    },*/
      valueGetter: (params) => {
      // Ensure the value is a number, provide 0 as a fallback
          return parseFloat(params.data.sellPutStrike) || 0;
      },
      valueFormatter: (params) => {
          // Convert to string with two decimal places and append '%'
          return `${formatCurrency(params.value)}`;
      },
      cellStyle: (params) => {
        if (parseFloat(params.data.lastSaleClose) < parseFloat(params.data.sellPutStrike)) {
            return { fontWeight: 'bold' };  // Apply bold style if the condition is met
        } else {
            return null;  // Return null for default styling
        }
      },
      cellRenderer: (params) => {
          // Use value formatter in cell renderer for consistency
          return params.valueFormatted;
      }
    },
    {headerName: "Buy Put Strike", field: "buyPutStrike", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:130, editable: false, cellClass: 'bordered-cell', resizable:true, 
      valueGetter: (params) => {
      // Ensure the value is a number, provide 0 as a fallback
          return parseFloat(params.data.buyPutStrike) || 0;
      },
      valueFormatter: (params) => {
          // Convert to string with two decimal places and append '%'
          return `${formatCurrency(params.value)}`;
      },
      cellStyle: (params) => {
        if (parseFloat(params.data.lastSaleClose) < parseFloat(params.data.buyPutStrike)) {
            return { fontWeight: 'bold' };  // Apply bold style if the condition is met
        } else {
            return null;  // Return null for default styling
        }
      },
      cellRenderer: (params) => {
          // Use value formatter in cell renderer for consistency
          return params.valueFormatted;
      }
    }
  ]
}

columns=[
  {headerName: "Id", field: "id", hide: true, valueGetter : row => {
    return row.data.id;
  },},
  {headerName: "email", field: "email", hide: true, valueGetter : row => {
    var emailRow=email.current;
    row.data.email=emailRow;
    return emailRow;
  },},
  //{headerName: "Delete", field: "delete", pinned: true, headerCheckboxSelection: false, checkboxSelection: true, minWidth:10, maxWidth:90},
  {
    headerName: "Delete",
    field: "delete",
    pinned: true,
    headerCheckboxSelection: false,
    checkboxSelection: true,
    minWidth: 10,
    maxWidth: 90,
    cellRenderer: (params) => {
      return (
        <span>
          {params.data.paperTrade && <img src="paper.png" style={{ width: "20px", height: "20px", marginRight: "5px" }} />}
          {params.value}
        </span>
      );
    }
  },
  {headerName: "Security", field: "security", sortable: true, filter: true, pinned: true, minWidth:10, maxWidth:90, resizable:true, editable: true,},
  {headerName: "Last Sale", field: "lastSaleClose", sortable: true, pinned: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:100, editable: false, resizable:true, /*cellRenderer: row =>{
    if (typeof(row.data.lastSaleClose) !== 'undefined') {
      if (isNaN(row.data.lastSaleClose)) {
        row.data.lastSaleClose=0;
        return row.data.lastSaleClose;
      } else {
          return row.data.lastSaleClose;
      }
    }
  },*/
    valueGetter: (params) => {
    // Ensure the value is a number, provide 0 as a fallback
        return parseFloat(params.data.lastSaleClose) || 0;
    },
    valueFormatter: (params) => {
        // Convert to string with two decimal places and append '%'
        return `${formatCurrency(params.value)}`;
    },
    cellRenderer: (params) => {
        // Use value formatter in cell renderer for consistency
        return params.valueFormatted;
    }
  },
  //Adding open trade - additional info to commit again
  {headerName: "Open Trade Date", field: "openTradeDate", sortable: true, filter: 'agDateColumnFilter', minWidth:50, maxWidth:100, editable: true, resizable:true, valueGetter: row =>{
  if (typeof(row.data.closeTradeDate) !== 'undefined') {
    console.log("row: openTradeDate org = "+row.data.openTradeDate.toString());
    if (row.data.openTradeDate.toString().indexOf("GMT")>0) {
      var openTradeDate=row.data.openTradeDate;
      openTradeDate=openTradeDate.toString().replace("GMT","");
      console.log("row: openTradeDate without GMT = "+openTradeDate);
      openTradeDate=getFormattedDate(new Date(openTradeDate));
      console.log("row: openTradeDate formatted = "+openTradeDate.toString());
      row.data.openTradeDate=openTradeDate
      return openTradeDate;
    } else {
        return row.data.openTradeDate;
    }
  }
  },},
  /*{headerName: "Profit / Loss %", field: "profitLossPercent", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:130, editable: false, resizable:true, cellRenderer: row =>{
    console.log ("row = ", row);
    if (typeof(row.data.exp) !== 'undefined') {
      if (isNaN(row.data.profitLossPercent)) {
        row.data.profitLossPercent=0;
        return row.data.profitLossPercent;
      } else {
          
          row.data.profitLossPercent = parseFloat(row.data.profitLossPercent).toFixed(2);
          console.log ("cell : row = ",row);
          return row.data.profitLossPercent;
      }
    }
  },
  },*/
  {
    headerName: "Profit / Loss %", 
    field: "profitLossPercent", 
    sortable: true, 
    filter: 'agNumberColumnFilter', 
    minWidth: 50, 
    maxWidth: 130, 
    editable: false, 
    resizable: true,
    valueGetter: (params) => {
        // Ensure the value is a number, provide 0 as a fallback
        return parseFloat(params.data.profitLossPercent) || 0;
    },
    valueFormatter: (params) => {
        // Convert to string with two decimal places and append '%'
        return `${params.value.toFixed(2)}%`;
    },
    cellStyle: (params) => {
      let breakEvenUp = (-1) * parseFloat(params.data.openCost) / (parseInt(params.data.contracts) * 100) + parseFloat(params.data.buyCallStrike);
      let breakEvenDown = parseFloat(params.data.buyPutStrike) - (-1) * parseFloat(params.data.openCost) / (parseInt(params.data.contracts) * 100);
      console.log ("breakEvenUp = " + breakEvenUp + "\tbreakEvenDown = " + breakEvenDown + "\tlastSaleClose = " + parseFloat(params.data.lastSaleClose));
      if ((parseFloat(params.data.lastSaleClose) > breakEvenUp ||
          parseFloat(params.data.lastSaleClose) < breakEvenDown) &&
          parseFloat(params.data.profitLossDollars) < 0 &&
          !isExpired(params.data.exp) && params.data.closeTradeDate.length === 0) {
          return { backgroundColor: '#f9cdaa' };  // Apply bold style if the condition is met
      } else {
          return null;  // Return null for default styling
      }
    },
    cellRenderer: (params) => {
        // Use value formatter in cell renderer for consistency
        return params.valueFormatted;
    }
  },
  {
    headerName: "Profit / Loss $", 
    field: "profitLossDollars", 
    sortable: true, 
    filter: 'agNumberColumnFilter', 
    minWidth: 50, 
    maxWidth: 130, 
    editable: false, 
    resizable: true,
    valueGetter: (params) => {
        // Ensure the value is a number, provide 0 as a fallback
        return parseFloat(params.data.profitLossDollars) || 0;
    },
    valueFormatter: (params) => {
        // Convert to string with two decimal places and append '%'
        return `${formatCurrency(params.value)}`;
    },
    cellStyle: (params) => {
      let breakEvenUp = (-1) * parseFloat(params.data.openCost) / (parseInt(params.data.contracts) * 100) + parseFloat(params.data.buyCallStrike);
      let breakEvenDown = parseFloat(params.data.buyPutStrike) - (-1) * parseFloat(params.data.openCost) / (parseInt(params.data.contracts) * 100);
      if ((parseFloat(params.data.lastSaleClose) > breakEvenUp ||
          parseFloat(params.data.lastSaleClose) < breakEvenDown) &&
          parseFloat(params.data.profitLossDollars) < 0 &&
          !isExpired(params.data.exp) && params.data.closeTradeDate.length === 0) {
          return { backgroundColor: '#f9cdaa' };  // Apply bold style if the condition is met
      } else {
          return null;  // Return null for default styling
      }
    },
    cellRenderer: (params) => {
        // Use value formatter in cell renderer for consistency
        return params.valueFormatted;
    }
  },
  {headerName: "Contracts", field: "contracts", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:100, editable: false, resizable:true, cellRenderer: row =>{
    if (typeof(row.data.exp) !== 'undefined') {
      if (isNaN(row.data.contracts)) {
        row.data.contracts=0;
        return row.data.contracts;
      } else {
          return row.data.contracts;
      }
    }
  },},
  {headerName: "Expiration", field: "exp", sortable: true, filter: 'agDateColumnFilter',minWidth:50, maxWidth:100, editable: true, resizable:true, valueGetter: row =>{
    if (typeof(row.data.exp) !== 'undefined') {
      console.log("row: exp org = "+row.data.exp.toString());
      if (row.data.exp.toString().indexOf("GMT")>0) {
        var expiration=row.data.exp;
        expiration=expiration.toString().replace("GMT","");
        console.log("row: expiration without GMT = "+expiration);
        expiration=getFormattedDate(new Date(expiration));
        console.log("row: expiration formatted = "+expiration.toString());
        row.data.exp=expiration
        return expiration;
      } else {
          return row.data.exp;
      }
    }
  },},
  
  ...strikeColumns,
  
  {headerName: "Open Cost", field: "openCost", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:120, editable: false, resizable:true, /*cellRenderer: row =>{
    if (typeof(row.data.exp) !== 'undefined') {
      if (isNaN(row.data.openCost)) {
        row.data.openCost=0;
        return row.data.openCost;
      } else {
          return row.data.openCost;
      }
    }
  },*/
    valueGetter: (params) => {
    // Ensure the value is a number, provide 0 as a fallback
        return parseFloat(params.data.openCost) || 0;
    },
    valueFormatter: (params) => {
        // Convert to string with two decimal places and append '%'
        return `${formatCurrency(params.value)}`;
    },
    cellRenderer: (params) => {
        // Use value formatter in cell renderer for consistency
        return params.valueFormatted;
    }
  },
  {headerName: "Close Cost", field: "closeCost", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:120, editable: false, resizable:true, /*cellRenderer: row =>{
    if (typeof(row.data.exp) !== 'undefined') {
      if (isNaN(row.data.closeCost)) {
        row.data.closeCost=0;
        return row.data.closeCost;
      } else {
          return row.data.closeCost;
      }
    }
  },*/
    valueGetter: (params) => {
    // Ensure the value is a number, provide 0 as a fallback
        return parseFloat(params.data.closeCost) || 0;
    },
    valueFormatter: (params) => {
        // Convert to string with two decimal places and append '%'
        return `${formatCurrency(params.value)}`;
    },
    cellRenderer: (params) => {
        // Use value formatter in cell renderer for consistency
        return params.valueFormatted;
    }
  },
  {headerName: "Close Trade Date", field: "closeTradeDate", sortable: true, sort: 'asc', filter: 'agDateColumnFilter', minWidth:50, maxWidth:100, editable: true, resizable:true, valueGetter: row =>{
    if (typeof(row.data.closeTradeDate) !== 'undefined') {
      console.log("row: closeTradeDate org = "+row.data.closeTradeDate.toString());
      if (row.data.closeTradeDate.toString().indexOf("GMT")>0) {
        var closeTradeDate=row.data.closeTradeDate;
        closeTradeDate=closeTradeDate.toString().replace("GMT","");
        console.log("row: closeTradeDate without GMT = "+closeTradeDate);
        closeTradeDate=getFormattedDate(new Date(closeTradeDate));
        console.log("row: closeTradeDate formatted = "+closeTradeDate.toString());
        row.data.closeTradeDate=closeTradeDate
        return closeTradeDate;
      } else {
          return row.data.closeTradeDate;
      }
    }
  },},

  {headerName: "Max Gain", field: "maxGain", hide: true, valueGetter : row => {
    return row.data.maxLoss;
  },},
  {headerName: "VIX Last Sale", field: "vixLastSale", hide: true, valueGetter : row => {
    return row.data.vixLastSale;
  },},
  {headerName: "MKT Direction", field: "mktDirection", hide: true, valueGetter : row => {
    return row.data.mktDirection;
  },},
  {headerName: "VIX Change", field: "vixChange", hide: true, valueGetter : row => {
    return row.data.vixChange;
  },},
  
  {headerName: "Details", field: "details", minWidth:50, maxWidth:100, editable: false, resizable:true, cellRenderer: (params) => { // Notice 'params' here
    console.log("headerName Details : params.api.getColumns = ", params.api.getColumns());
    console.log("headerName Details : params.data = ", params.data);
    const handleClick = () => {
      let dataJson = params.data;
      handleEditClick(params.data); // Pass the row data
    };

    if (isNaN(params.data.details)) {
      return <span onClick={handleClick}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>; // Wrap in span for click
    } else {
      return <span onClick={handleClick}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>; 
    }
 
  }, 
}
];

const onSelectionChanged=() =>{
  console.log ("Executing onSelectionChanged");
  let commitDelete="";
  let selectedRowsNumber=gridRef.current.api.getSelectedRows().length;
  console.log("onSelectionChanged : gridRef.current.api.getSelectedRows().length = " + selectedRowsNumber);

  if (selectedRowsNumber>=numberOfChecked.current) {
    commitDelete="delete";
    numberOfChecked.current++;
  } else {
    commitDelete="commit";
    numberOfChecked.current--;
  }

  console.log("onSelectionChanged : commitDelete = "+commitDelete);
 
  if (selectedRowsNumber > 0) {
    console.log("onSelectionChanged : gridRef = ", gridRef);
    console.log("onSelectionChanged : getSelectedNodes = ", gridRef.current.api.getSelectedNodes());
    console.log("onSelectionChanged : checkboxSelected = ", gridRef.current.checkboxSelected);
    console.log("onSelectionChanged : getDisplayedRowCount = "+gridRef.current.api.getDisplayedRowCount());
    const selectedRowIndex=gridRef.current.api.getFocusedCell().rowIndex;
    console.log("onSelectionChanged : selectedRowIndex = " + selectedRowIndex);
    console.log("onSelectionChanged : getDisplayedRowAtIndex = ", gridRef.current.api.getDisplayedRowAtIndex(selectedRowIndex));

    const selectedRows = gridRef.current.api.getDisplayedRowAtIndex(selectedRowIndex).data;
    console.log("onSelectionChanged : selectedRows = ", selectedRows);

    if (commitDelete==="delete") {
      deleteRecIds.current.push(selectedRows.id);
    }

    if (commitDelete==="commit") {
      for (let delInd = 0; delInd < deleteRecIds.current.length; delInd++) {
        if (deleteRecIds.current[delInd] === selectedRows.id) {
          deleteRecIds.current.splice(delInd,1);
        }
      }
    }

    console.log("onSelectionChanged : deleteRecIds = ", deleteRecIds);
  }
}

async function commitChanges() {
  console.log ("Executing commitChanges");
  if (deleteRecIds.current.length>0) {
    console.log("commitChanges : deleteRecIds.current = ", deleteRecIds.current);
    path = '/deleteIronCondorTransactions';
    
    let delArrStr = "";
    for (let delInd = 0; delInd < deleteRecIds.current.length; delInd++) {
      delArrStr = delArrStr + "'" + deleteRecIds.current[delInd] + "'";
      if (delInd < deleteRecIds.current.length - 1) {
        delArrStr = delArrStr + ",";
      }
    }

    let passApiStr=path + "/" + delArrStr;
    console.log("commitChanges : passApistr = " + passApiStr);
    //await get(myAPI, passApistr)
    const response = await get({
      apiName: myAPI,
      path: passApiStr,
    }).response;
    let resp = await response.body.text();
    await Promise.resolve(resp)
    .then(async () => {
      await console.log("commitChanges : response = ", resp);
      if (resp.toString().indexOf("Successfully") > 0) {
        await console.log("commitChanges : successfully deleted");
        deleteRecIds.current = [];
        let recDelVal =recsWereDeleted * (-1);
        calledGetMyTransactions.current = false;
        await setRecsWereDeleted(recDelVal);
         
      } else {
         setDisplayMainMessage(error.message);
         console.log(error)
      }
   })
    .catch(error => {
       setDisplayMainMessage(error.message);
       console.log(error)
    })

  }

}

function generateTimestamp() {
  //console.log("Executing generateTimestamp");
  const currentDate = new Date();
  let currentTimestamp = currentDate.getTime();
  let currentTimestampInt = parseInt(currentTimestamp);
  currentTimestampInt = parseInt(currentTimestampInt / 1000);
  currentTimestamp = currentTimestampInt.toString();
  //console.log('Current timestamp:', currentTimestamp);

  return currentTimestamp;
};

function addEmptyRow() {
  console.log ("Executing addEmptyRow");

  selectedRecord.current = {};

  const fieldsToValidate = [
    'sellCallStrike', 'buyCallStrike', 'buyPutStrike', 'sellPutStrike',
    'sellCallOpenCost', 'buyCallOpenCost', 'buyPutOpenCost', 'sellPutOpenCost', 
    "sellCallOpenQuote", "buyCallOpenQuote", "buyPutOpenQuote", "sellPutOpenQuote", 
    "lastSale", "netAmount", "openCost",
    "sellCallCloseQuote", "sellCallCloseCost", "buyCallCloseQuote", "buyCallCloseCost",
    "buyPutCloseQuote", "buyPutCloseCost", "sellPutCloseQuote", "sellPutCloseCost",
    "lastSaleClose", "netAmountClose", "closeCost",
    "closeTradeDate", "desiredProfitPercent", "desiredNetAmount",
    "profitLossDollars", "profitLossPercent",
    "commissionFee", "maxLoss", "upper", "lower", "days"
  ];

  for (let field of fieldsToValidate) {
    selectedRecord.current[field] = 0;
  }

  selectedRecord.current["contracts"] = 1;
  selectedRecord.current["security"] = "";
  selectedRecord.current["exp"] = "";
  selectedRecord.current["openTradeDate"] = "";

  selectedRecord.current["id"] = generateTimestamp();

  selectedRecord.current["position"] = "";
  selectedRecord.current["email"] = email.current;
  selectedRecord.current["closeTradeDate"] = "";

  selectedRecord.current["paperTrade"] = false;

  selectedRecord.current["sellCallStrikeUpdate"] = false;
  selectedRecord.current["buyCallStrikeUpdate"] = false;
  selectedRecord.current["buyPutStrikeUpdate"] = false;
  selectedRecord.current["sellPutStrikeUpdate"] = false;

  setIsEditing(true);
}

function EditForm({ record, onSubmit, onReset }) {
  console.log("Executing EditForm");
  let [formData, setFormData] = useState(record);
  const formDataRef = useRef(record); // Synchronous ref to avoid race condition
  let [showEditSubmitError, setShowEditSubmitError] = useState(false);
  let [displayMessage, setDisplayMessage] = useState();

  let initialDate = record.exp ? new Date(`${record.exp}T00:00:00`) : null;
  console.log("EditForm : exp : initialDate = " + initialDate);
  let [selectedExp, setSelectedExp] = useState(initialDate);

  initialDate = record.openTradeDate ? new Date(`${record.openTradeDate}T00:00:00`) : null;
  console.log("EditForm : openTradeDate : initialDate = " + initialDate);
  let [selectedOpenTradeDate, setSelectedOpenTradeDate] = useState(initialDate);

  initialDate = record.closeTradeDate ? new Date(`${record.closeTradeDate}T00:00:00`) : null;
  console.log("EditForm : closeTradeDate : initialDate = " + initialDate);
  let [selectedCloseTradeDate, setSelectedCloseTradeDate] = useState(initialDate);

  console.log("EditForm : record = ", record);

  const handleChange = (event) => {
    console.log("Executing handleChange");
    setShowEditSubmitError(false);
    console.log("handleChange : event = ", event);
    console.log("handleChange : formData = ", formData);

    const { type, name, value, checked } = event.target;

    let commissionClose = 0.65;

    //let targetValue = 0;
    let targetValue;
    if (type === "checkbox") {
      if (event.target.checked === true) {
        targetValue = true;
      } else {
        targetValue = false;
      }
    } else {
      targetValue = event.target.value;
    }
    console.log ("handleChange : event.target.name = " + event.target.name);
    console.log ("handleChange : targetValue = " + targetValue);

    let orgOpenCostFee = parseFloat(formData.openCost) - (parseFloat(formData.sellCallOpenCost) + parseFloat(formData.buyCallOpenCost) + parseFloat(formData.buyPutOpenCost) + parseFloat(formData.sellPutOpenCost));
    console.log("handleChange : orgOpenCostFee = " + orgOpenCostFee);

    // Store old contract count and costs before updating (for proportional scaling)
    const oldContracts = parseFloat(formData.contracts) || 1;
    const oldCosts = {
      sellCallOpenCost: parseFloat(formData.sellCallOpenCost) || 0,
      buyCallOpenCost: parseFloat(formData.buyCallOpenCost) || 0,
      buyPutOpenCost: parseFloat(formData.buyPutOpenCost) || 0,
      sellPutOpenCost: parseFloat(formData.sellPutOpenCost) || 0,
      sellCallCloseCost: parseFloat(formData.sellCallCloseCost) || 0,
      buyCallCloseCost: parseFloat(formData.buyCallCloseCost) || 0,
      buyPutCloseCost: parseFloat(formData.buyPutCloseCost) || 0,
      sellPutCloseCost: parseFloat(formData.sellPutCloseCost) || 0
    };

    // Cloning formData for manipulation
    let updatedFormData = {...formData};

    updatedFormData[event.target.name] = targetValue;
    console.log ("handleChange : updatedFormData = ", updatedFormData);

    if (event.target.name !== "security" && event.target.name !== "exp" && event.target.name !== "openTradeDate" && event.target.name !== "closeTradeDate") {
      console.log ("handleChange : event.target.name = ", event.target.name);

      // If contracts changed, scale all costs proportionally
      if (event.target.name === "contracts" && updatedFormData.contracts.toString().trim() !== "") {
        const newContracts = parseFloat(updatedFormData.contracts);
        const ratio = newContracts / oldContracts;

        // Scale opening costs proportionally
        updatedFormData.sellCallOpenCost = (oldCosts.sellCallOpenCost * ratio).toFixed(2);
        updatedFormData.buyCallOpenCost = (oldCosts.buyCallOpenCost * ratio).toFixed(2);
        updatedFormData.buyPutOpenCost = (oldCosts.buyPutOpenCost * ratio).toFixed(2);
        updatedFormData.sellPutOpenCost = (oldCosts.sellPutOpenCost * ratio).toFixed(2);

        // Scale closing costs proportionally
        updatedFormData.sellCallCloseCost = (oldCosts.sellCallCloseCost * ratio).toFixed(2);
        updatedFormData.buyCallCloseCost = (oldCosts.buyCallCloseCost * ratio).toFixed(2);
        updatedFormData.buyPutCloseCost = (oldCosts.buyPutCloseCost * ratio).toFixed(2);
        updatedFormData.sellPutCloseCost = (oldCosts.sellPutCloseCost * ratio).toFixed(2);
      }

      // For all other fields (NOT contracts), calculate quotes from costs
      // When contracts change, we already scaled costs proportionally above, so skip this
      if (event.target.name !== "contracts") {
        if (updatedFormData.sellCallOpenCost.toString().trim() !== "" && updatedFormData.contracts.toString().trim() !== "")
          updatedFormData.sellCallOpenQuote = (parseFloat(updatedFormData.sellCallOpenCost) / parseFloat(updatedFormData.contracts) / 100).toFixed(2);
        else {
          updatedFormData.sellCallOpenQuote = 0;
        }
        if (updatedFormData.buyCallOpenCost.toString().trim() !== "" && updatedFormData.contracts.toString().trim() !== "") {
          updatedFormData.buyCallOpenQuote = (parseFloat(updatedFormData.buyCallOpenCost) / parseFloat(updatedFormData.contracts) / 100).toFixed(2);
        } else {
          updatedFormData.buyCallOpenQuote = 0;
        }
        if (updatedFormData.buyPutOpenCost.toString().trim() !== "" && updatedFormData.contracts.toString().trim() !== "") {
          updatedFormData.buyPutOpenQuote = (parseFloat(updatedFormData.buyPutOpenCost) / parseFloat(updatedFormData.contracts) / 100).toFixed(2);
        } else {
          updatedFormData.buyPutOpenQuote = 0;
        }
        if (updatedFormData.sellPutOpenCost.toString().trim() !== "" && updatedFormData.contracts.toString().trim() !== "") {
          updatedFormData.sellPutOpenQuote = (parseFloat(updatedFormData.sellPutOpenCost) / parseFloat(updatedFormData.contracts) / 100).toFixed(2);
        } else {
          updatedFormData.sellPutOpenQuote = 0;
        }
      }
      
      let netAmount = (parseFloat(updatedFormData.sellCallOpenQuote) + parseFloat(updatedFormData.buyCallOpenQuote) + parseFloat(updatedFormData.sellPutOpenQuote) + parseFloat(updatedFormData.buyPutOpenQuote)).toFixed(2);

      // For all other fields (NOT contracts), calculate close quotes from costs
      // When contracts change, we already scaled costs proportionally above, so skip this
      if (event.target.name !== "contracts") {
        if (updatedFormData.sellCallCloseCost.toString().trim() !== "" && updatedFormData.contracts.toString().trim() !== "") {
          updatedFormData.sellCallCloseQuote = (parseFloat(updatedFormData.sellCallCloseCost) / parseFloat(updatedFormData.contracts) / 100).toFixed(2);
        } else {
          updatedFormData.sellCallCloseQuote = 0;
        }
        if (updatedFormData.buyCallCloseCost.toString().trim() !== "" && updatedFormData.contracts.toString().trim() !== "") {
          updatedFormData.buyCallCloseQuote = (parseFloat(updatedFormData.buyCallCloseCost) / parseFloat(updatedFormData.contracts) / 100).toFixed(2);
        } else {
          updatedFormData.buyCallCloseQuote = 0;
        }
        if (updatedFormData.buyPutCloseCost.toString().trim() !== "" && updatedFormData.contracts.toString().trim() !== "") {
          updatedFormData.buyPutCloseQuote = (parseFloat(updatedFormData.buyPutCloseCost) / parseFloat(updatedFormData.contracts) / 100).toFixed(2);
        } else {
          updatedFormData.buyPutCloseQuote = 0;
        }
        if (updatedFormData.sellPutCloseCost.toString().trim() !== "" && updatedFormData.contracts.toString().trim() !== "") {
          updatedFormData.sellPutCloseQuote = (parseFloat(updatedFormData.sellPutCloseCost) / parseFloat(updatedFormData.contracts) / 100).toFixed(2);
        } else {
          updatedFormData.sellPutCloseQuote = 0;
        }
      }

      let netAmountClose = (parseFloat(updatedFormData.sellCallCloseQuote) + parseFloat(updatedFormData.buyCallCloseQuote) + parseFloat(updatedFormData.sellPutCloseQuote) + parseFloat(updatedFormData.buyPutCloseQuote)).toFixed(2);

      let openCostFee = 0;
      if (updatedFormData.sellCallOpenCost.toString().trim() !== "" &&
        updatedFormData.buyCallOpenCost.toString().trim() !== "" &&
        updatedFormData.buyPutOpenCost.toString().trim() !== "" &&
        updatedFormData.sellPutOpenCost.toString().trim() !== ""
      ) {
          if (event.target.name === "includeCommissionFee" && event.target.checked === false) {
            openCostFee = (parseFloat(updatedFormData.sellCallOpenCost) + parseFloat(updatedFormData.buyCallOpenCost) + parseFloat(updatedFormData.buyPutOpenCost) + parseFloat(updatedFormData.sellPutOpenCost)).toFixed(2);
          } else if (event.target.name === "includeCommissionFee" && event.target.checked === true) {
              openCostFee = (parseFloat(updatedFormData.sellCallOpenCost) + parseFloat(updatedFormData.buyCallOpenCost) + parseFloat(updatedFormData.buyPutOpenCost) + parseFloat(updatedFormData.sellPutOpenCost) - parseFloat(updatedFormData.commissionFee)).toFixed(2);
          } else if (updatedFormData.includeCommissionFee === "true") {
              openCostFee = (parseFloat(updatedFormData.sellCallOpenCost) + parseFloat(updatedFormData.buyCallOpenCost) + parseFloat(updatedFormData.buyPutOpenCost) + parseFloat(updatedFormData.sellPutOpenCost) - parseFloat(updatedFormData.commissionFee)).toFixed(2);
          } else {
              openCostFee = (parseFloat(updatedFormData.sellCallOpenCost) + parseFloat(updatedFormData.buyCallOpenCost) + parseFloat(updatedFormData.buyPutOpenCost) + parseFloat(updatedFormData.sellPutOpenCost)).toFixed(2);
          }
        }
      
      console.log("handleChange : openCostFee = " + openCostFee);

      let closeCostFee = 0;
      if (updatedFormData.sellCallCloseCost.toString().trim() !== "" &&
        updatedFormData.buyCallCloseCost.toString().trim() !== "" &&
        updatedFormData.buyPutCloseCost.toString().trim() !== "" &&
        updatedFormData.sellPutCloseCost.toString().trim() !== ""
      ) {
        closeCostFee = (parseFloat(updatedFormData.sellCallCloseCost) + parseFloat(updatedFormData.buyCallCloseCost) + parseFloat(updatedFormData.buyPutCloseCost) + parseFloat(updatedFormData.sellPutCloseCost)).toFixed(2);
      }

      updatedFormData["netAmount"] = netAmount;
      updatedFormData["netAmountClose"] = netAmountClose;
      updatedFormData["openCost"] = openCostFee;
      updatedFormData["closeCost"] = closeCostFee;

      updatedFormData["profitLossDollars"] = (parseFloat(updatedFormData["openCost"]) + parseFloat(updatedFormData["closeCost"]));
      if (parseFloat(updatedFormData["openCost"]) !== 0) {
        if (updatedFormData["openCost"] <0) {
          updatedFormData["profitLossPercent"] = (parseFloat(updatedFormData["profitLossDollars"]) / parseFloat(updatedFormData["openCost"]) * 100) * (-1);
        } else {
          updatedFormData["profitLossPercent"] = (parseFloat(updatedFormData["profitLossDollars"]) / parseFloat(updatedFormData["openCost"]) * 100)
        }
      } else {
        updatedFormData["profitLossPercent"] = 0;
      }
      updatedFormData["profitLossDollars"] = parseFloat(updatedFormData["profitLossDollars"]).toFixed(2);
      updatedFormData["profitLossPercent"] = parseFloat(updatedFormData["profitLossPercent"]).toFixed(2);
    }

    if (event.target.name === "desiredProfitPercent") {
      if (updatedFormData["desiredProfitPercent"] === "" ) {
        updatedFormData["desiredProfitPercent"] = 0.0;
      }
      let netAmount = (parseFloat(updatedFormData.sellCallOpenQuote) + parseFloat(updatedFormData.buyCallOpenQuote) + parseFloat(updatedFormData.sellPutOpenQuote) + parseFloat(updatedFormData.buyPutOpenQuote)).toFixed(2);
      let desiredNetAmount = 0;
      if (netAmount < 0) {
        desiredNetAmount = ((-1) * parseFloat(netAmount) * parseFloat(updatedFormData.desiredProfitPercent) / 100 + (-1) * parseFloat(netAmount)).toFixed(2);
      } else {
        desiredNetAmount = parseFloat(netAmount) * parseFloat(updatedFormData.desiredProfitPercent) / 100 + parseFloat(netAmount);
      }
      updatedFormData["desiredNetAmount"] = desiredNetAmount;
    }

    console.log("handleChange : after all changes : updatedFormData = ", updatedFormData);
    formDataRef.current = updatedFormData; // Update ref synchronously
    setFormData(updatedFormData);
  };

  function handleChangeExpDate(date) {
    console.log("Executing handleChangeDate");
    console.log("handleChangeDate : date = ", date);

    if (!date) {
        setSelectedExp(null);
        setFormData(prevFormData => ({ ...prevFormData, exp: '' }));
        return;
    }

    // Format the date as YYYY-MM-DD string immediately upon selection
    const formattedDate = formatDate(date);
    console.log("handleChangeDate : formattedDate = ", formattedDate);

    // Update state with the formatted string
    setSelectedExp(new Date(date)); // This ensures DatePicker receives a Date object
    setFormData(prevFormData => ({ ...prevFormData, exp: formattedDate }));
  }

  function handleChangeOpenDate(date) {
    console.log("Executing handleChangeDate");
    console.log("handleChangeDate : date = ", date);

    if (!date) {
        setSelectedOpenTradeDate(null);
        setFormData(prevFormData => ({ ...prevFormData, openTradeDate: '' }));
        return;
    }

    // Format the date as YYYY-MM-DD string immediately upon selection
    const formattedDate = formatDate(date);
    console.log("handleChangeDate : formattedDate = ", formattedDate);

    // Update state with the formatted string
    setSelectedOpenTradeDate(new Date(date)); // This ensures DatePicker receives a Date object
    setFormData(prevFormData => ({ ...prevFormData, openTradeDate: formattedDate }));
  }

  function handleChangeCloseDate(date) {
    console.log("Executing handleChangeDate");
    console.log("handleChangeDate : date = ", date);

    if (!date) {
        setSelectedCloseTradeDate(null);
        setFormData(prevFormData => ({ ...prevFormData, closeTradeDate: '' }));
        return;
    }

    // Format the date as YYYY-MM-DD string immediately upon selection
    const formattedDate = formatDate(date);
    console.log("handleChangeDate : formattedDate = ", formattedDate);

    // Update state with the formatted string
    setSelectedCloseTradeDate(new Date(date)); // This ensures DatePicker receives a Date object
    setFormData(prevFormData => ({ ...prevFormData, closeTradeDate: formattedDate }));
  }

  function formatDate(dateString) {
    if (dateString !== "") {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Add 1 for zero-based months
      const day = date.getDate().toString().padStart(2, '0'); 
    
      return `${year}-${month}-${day}`;
    } else {
      return "";
    }
  }

  const handleEditSubmit = async (event) => {
    if (event) event.preventDefault(); // Prevent default form submission

    // Use formDataRef to get the most current values (fixes race condition with setState)
    const currentFormData = formDataRef.current;

    await console.log("Executing handleEditSubmit");
    await console.log ("handleEditSubmit : formData = ", currentFormData);

    const fieldsToValidateNumbers = [
      'sellCallStrike', 'buyCallStrike', 'buyPutStrike', 'sellPutStrike',
      'sellCallOpenCost', 'buyCallOpenCost', 'buyPutOpenCost', 'sellPutOpenCost', 'contracts',
      'sellCallCloseCost', 'buyCallCloseCost', 'buyPutCloseCost', 'sellPutCloseCost'
    ];

    const fieldsToValidateText = [
      'security', 'exp', 'openTradeDate'
    ];

    for (let field of fieldsToValidateText) {
      await console.log ("handleEditSubmit : currentFormData[" + field + "] = " + currentFormData[field]);
      if (!currentFormData[field]) {
        setDisplayMessage(`Error: ${field} cannot be blank.`);
        setShowEditSubmitError(true);
        return;
      }
    }

    for (let field of fieldsToValidateNumbers) {
      await console.log ("handleEditSubmit : currentFormData[" + field + "] = " + currentFormData[field]);
      if (currentFormData[field] === "NaN" || currentFormData[field].toString().trim() === "") {
        setDisplayMessage(`Error: ${field} cannot be blank.`);
        setShowEditSubmitError(true);
        return;
      }
      if (isNaN(parseFloat(currentFormData[field]))) {
        setDisplayMessage(`Error: ${field} must be a number`);
        setShowEditSubmitError(true);
        return;
      }
      /*else if (parseFloat(formData[field]) === 0) {
        setDisplayMessage(`Error: ${field} cannot be 0`);
        setShowEditSubmitError(true);
        return;
      }*/
    }

    currentFormData["security"] = currentFormData["security"].toString().toUpperCase();

    if (currentFormData["buyCallStrikeUpdate"]) {
      currentFormData["buyCallStrikeUpdate"] = "false";
    } else {
      currentFormData["buyCallStrikeUpdate"] = "true";
    }

    if (currentFormData["sellCallStrikeUpdate"]) {
      currentFormData["sellCallStrikeUpdate"] = "false";
    } else {
      currentFormData["sellCallStrikeUpdate"] = "true";
    }

    if (currentFormData["buyPutStrikeUpdate"]) {
      currentFormData["buyPutStrikeUpdate"] = "false";
    } else {
      currentFormData["buyPutStrikeUpdate"] = "true";
    }

    if (currentFormData["sellPutStrikeUpdate"]) {
      currentFormData["sellPutStrikeUpdate"] = "false";
    } else {
      currentFormData["sellPutStrikeUpdate"] = "true";
    }
    await console.log ("handleEditSubmit : checking paperTrade");
    if (currentFormData["paperTrade"]) {
      currentFormData["paperTrade"] = "true";
    } else {
      currentFormData["paperTrade"] = "false";
    }

    await console.log ("handleEditSubmit : checking includeCommissionFee");
    if (currentFormData["includeCommissionFee"]) {
      currentFormData["includeCommissionFee"] = "true";
    } else {
      currentFormData["includeCommissionFee"] = "false";
    }

    await console.log("handleEditSubmit : currentFormData = ", currentFormData);
    path = '/saveIronCondorOptionsEdits';

    var passApiStr=path + "/" + JSON.stringify(currentFormData);
    console.log("passApiStr = "+passApiStr);
    //await get(myAPI, passApistr)
    const response = await get({
      apiName: myAPI,
      path: passApiStr,
    }).response;
    let resp = await response.body.json();
    await Promise.resolve(resp)
       .then(async () => {
         await console.log("MyPortfolioIronCondor : response = " + JSON.stringify(resp));
         await console.log(resp);
         if (resp.toString().indexOf("Successfully") > 0) {
            calledGetMyTransactions.current = false;
            await getMyTransactions(email.current)
            .then (()=>{
              setIsEditing(false);
            })
            
         } else {
            setShowEditSubmitError(true);
            setDisplayMessage(error.message);
            console.log(error)
         }
      })
       .catch(error => {
          setShowEditSubmitError(true);
          setDisplayMessage(error.message);
          console.log(error)
       })
    //setIsEditing(false); // Close the form
  };

  const handleEditReset = () => {
    console.log("Executing handleEditReset");
    setShowEditSubmitError(false);
    console.log("handleEditReset : record = ", record);
    formDataRef.current = record; // Update ref synchronously
    setFormData(record); // Set form data back to original values
  };

  const handleEditBack = () => {
    setShowEditSubmitError(false);
    setIsEditing(false);
  }

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '24px' }}>
      {/* Page Title */}
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)' }}>
          Edit Iron Condor Trade
        </h1>
      </div>

      {/* Error Message */}
      {showEditSubmitError && (
        <div className="blink_me_red" style={{
          marginBottom: '16px',
          textAlign: 'center',
          fontSize: '16px',
          padding: '12px'
        }}>
          {displayMessage}
        </div>
      )}

      <form onSubmit={handleEditSubmit}>
        {/* Trade Information Panel */}
        <div className="landing-panel" style={{ marginBottom: '24px' }}>
          <div className="landing-panel-header">
            <h2 className="landing-panel-title">📊 Trade Information</h2>
          </div>
          <div className="landing-panel-content">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              {/* Security */}
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  Security:
                </label>
                <input
                  type="text"
                  id="security"
                  name="security"
                  value={formData.security}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />
              </div>

              {/* Expiration */}
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  Expiration:
                </label>
                <DatePicker
                  selected={selectedExp}
                  onChange={handleChangeExpDate}
                  dateFormat="yyyy-MM-dd"
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />
              </div>

              {/* Contracts */}
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  Contracts:
                </label>
                <input
                  type="text"
                  id="contracts"
                  name="contracts"
                  value={formData.contracts}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />
              </div>

              {/* Open Trade Date */}
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  Open Trade Date:
                </label>
                <DatePicker
                  selected={selectedOpenTradeDate}
                  onChange={handleChangeOpenDate}
                  dateFormat="yyyy-MM-dd"
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />
              </div>

              {/* Paper Trade */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <input
                  type="checkbox"
                  id="paperTrade"
                  name="paperTrade"
                  checked={formData.paperTrade}
                  onChange={handleChange}
                  style={{
                    width: '20px',
                    height: '20px',
                    cursor: 'pointer'
                  }}
                />
                <label htmlFor="paperTrade" style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', cursor: 'pointer' }}>
                  Paper Trade
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* Breakeven Panel */}
        <div className="landing-panel" style={{ marginBottom: '24px' }}>
          <div className="landing-panel-header">
            <h2 className="landing-panel-title">🎯 Breakeven Points</h2>
          </div>
          <div className="landing-panel-content">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              {/* Lower Breakeven */}
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  Lower Breakeven:
                </label>
                <input
                  type="text"
                  id="lowerBreakeven"
                  name="lowerBreakeven"
                  value={formData.lowerBreakeven}
                  onChange={handleChange}
                  readOnly
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: 'rgba(243, 244, 246, 1)'
                  }}
                />
              </div>

              {/* Upper Breakeven */}
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  Upper Breakeven:
                </label>
                <input
                  type="text"
                  id="upperBreakeven"
                  name="upperBreakeven"
                  value={formData.upperBreakeven}
                  onChange={handleChange}
                  readOnly
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: 'rgba(243, 244, 246, 1)'
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Open Trade Panel */}
        <div className="landing-panel" style={{ marginBottom: '24px' }}>
          <div className="landing-panel-header" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <h2 className="landing-panel-title">💰 Open Trade</h2>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginLeft: 'auto' }}>
              <input
                type="checkbox"
                id="includeCommissionFee"
                name="includeCommissionFee"
                checked={formData.includeCommissionFee}
                onChange={handleChange}
                style={{
                  width: '20px',
                  height: '20px',
                  cursor: 'pointer'
                }}
              />
              <label htmlFor="includeCommissionFee" style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.8)', cursor: 'pointer', marginRight: '12px' }}>
                Include Commission Fee:
              </label>
              <input
                type="text"
                id="commissionFee"
                name="commissionFee"
                value={formData.commissionFee}
                onChange={handleChange}
                readOnly
                style={{
                  width: '80px',
                  padding: '4px 8px',
                  border: '1px solid rgba(209, 213, 219, 1)',
                  borderRadius: '6px',
                  fontSize: '14px',
                  background: 'rgba(243, 244, 246, 1)'
                }}
              />
            </div>
          </div>
          <div className="landing-panel-content">
            {record.position === "LONG" ? (
              <>
                {/* Sell Call Strike */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '180px 1fr 100px 1fr 100px 1fr',
                  gap: '12px',
                  alignItems: 'center',
                  marginBottom: '12px',
                  padding: '12px',
                  background: 'rgba(254, 242, 242, 1)',
                  borderRadius: '8px'
                }}>
                  <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)' }}>Sell Call Strike:</label>
                  <input
                    type="text"
                    id="sellCallStrike"
                    name="sellCallStrike"
                    value={formData.sellCallStrike}
                    onChange={handleChange}
                    style={{
                      padding: '8px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px'
                    }}
                  />
                  <label style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.7)' }}>Quote:</label>
                  <input
                    type="text"
                    id="sellCallOpenQuote"
                    name="sellCallOpenQuote"
                    value={formData.sellCallOpenQuote}
                    onChange={handleChange}
                    readOnly
                    style={{
                      padding: '8px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px',
                      background: 'rgba(243, 244, 246, 1)'
                    }}
                  />
                  <label style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.7)' }}>Cost:</label>
                  <input
                    type="text"
                    id="sellCallOpenCost"
                    name="sellCallOpenCost"
                    value={formData.sellCallOpenCost}
                    onChange={handleChange}
                    style={{
                      padding: '8px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px'
                    }}
                  />
                </div>

                {/* Buy Call Strike */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '180px 1fr 100px 1fr 100px 1fr',
                  gap: '12px',
                  alignItems: 'center',
                  marginBottom: '12px',
                  padding: '12px',
                  background: 'rgba(240, 253, 244, 1)',
                  borderRadius: '8px'
                }}>
                  <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)' }}>Buy Call Strike:</label>
                  <input
                    type="text"
                    id="buyCallStrike"
                    name="buyCallStrike"
                    value={formData.buyCallStrike}
                    onChange={handleChange}
                    style={{
                      padding: '8px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px'
                    }}
                  />
                  <label style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.7)' }}>Quote:</label>
                  <input
                    type="text"
                    id="buyCallOpenQuote"
                    name="buyCallOpenQuote"
                    value={formData.buyCallOpenQuote}
                    onChange={handleChange}
                    readOnly
                    style={{
                      padding: '8px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px',
                      background: 'rgba(243, 244, 246, 1)'
                    }}
                  />
                  <label style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.7)' }}>Cost:</label>
                  <input
                    type="text"
                    id="buyCallOpenCost"
                    name="buyCallOpenCost"
                    value={formData.buyCallOpenCost}
                    onChange={handleChange}
                    style={{
                      padding: '8px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px'
                    }}
                  />
                </div>

                {/* Buy Put Strike */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '180px 1fr 100px 1fr 100px 1fr',
                  gap: '12px',
                  alignItems: 'center',
                  marginBottom: '12px',
                  padding: '12px',
                  background: 'rgba(240, 253, 244, 1)',
                  borderRadius: '8px'
                }}>
                  <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)' }}>Buy Put Strike:</label>
                  <input
                    type="text"
                    id="buyPutStrike"
                    name="buyPutStrike"
                    value={formData.buyPutStrike}
                    onChange={handleChange}
                    style={{
                      padding: '8px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px'
                    }}
                  />
                  <label style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.7)' }}>Quote:</label>
                  <input
                    type="text"
                    id="buyPutOpenQuote"
                    name="buyPutOpenQuote"
                    value={formData.buyPutOpenQuote}
                    onChange={handleChange}
                    readOnly
                    style={{
                      padding: '8px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px',
                      background: 'rgba(243, 244, 246, 1)'
                    }}
                  />
                  <label style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.7)' }}>Cost:</label>
                  <input
                    type="text"
                    id="buyPutOpenCost"
                    name="buyPutOpenCost"
                    value={formData.buyPutOpenCost}
                    onChange={handleChange}
                    style={{
                      padding: '8px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px'
                    }}
                  />
                </div>

                {/* Sell Put Strike */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '180px 1fr 100px 1fr 100px 1fr',
                  gap: '12px',
                  alignItems: 'center',
                  marginBottom: '12px',
                  padding: '12px',
                  background: 'rgba(254, 242, 242, 1)',
                  borderRadius: '8px'
                }}>
                  <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)' }}>Sell Put Strike:</label>
                  <input
                    type="text"
                    id="sellPutStrike"
                    name="sellPutStrike"
                    value={formData.sellPutStrike}
                    onChange={handleChange}
                    style={{
                      padding: '8px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px'
                    }}
                  />
                  <label style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.7)' }}>Quote:</label>
                  <input
                    type="text"
                    id="sellPutOpenQuote"
                    name="sellPutOpenQuote"
                    value={formData.sellPutOpenQuote}
                    onChange={handleChange}
                    readOnly
                    style={{
                      padding: '8px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px',
                      background: 'rgba(243, 244, 246, 1)'
                    }}
                  />
                  <label style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.7)' }}>Cost:</label>
                  <input
                    type="text"
                    id="sellPutOpenCost"
                    name="sellPutOpenCost"
                    value={formData.sellPutOpenCost}
                    onChange={handleChange}
                    style={{
                      padding: '8px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px'
                    }}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="form-row"> 
              <div className="form-group">
                <div className="form-field-container">
                  <strong><label htmlFor="buyCallStrike">Buy Call Strike:</label></strong>
                  <input 
                    type="text" 
                    id="buyCallStrike" 
                    name="buyCallStrike"
                    value={formData.buyCallStrike} 
                    onChange={handleChange} 
                  />
                  <strong><label htmlFor="buyCallOpenQuote">Quote:</label></strong>
                  <input 
                    type="text" 
                    id="buyCallOpenQuote" 
                    name="buyCallOpenQuote"
                    //value={parseFloat(formData.buyCallOpenCost) / parseInt(formData.contracts) / 100} 
                    value = {formData.buyCallOpenQuote}
                    onChange={handleChange} 
                    readOnly
                  />
                  <strong><label htmlFor="buyCallOpenCost">Cost:</label></strong>
                  <input 
                    type="text" 
                    id="buyCallOpenCost" 
                    name="buyCallOpenCost"
                    value={formData.buyCallOpenCost} 
                    onChange={handleChange} 
                  />
                  
                </div>
              </div>
            </div>  
            <div className="form-row"> 
              <div className="form-group">
                <div className="form-field-container">
                  <strong><label className="form-label"   htmlFor="sellCallStrike">Sell Call Strike:</label></strong>
                  <input 
                    type="text" 
                    id="sellCallStrike" 
                    name="sellCallStrike"
                    value={formData.sellCallStrike} 
                    onChange={handleChange} 
                  />
                  <strong><label htmlFor="sellCallOpenQuote">Quote:</label></strong>
                  <input 
                    type="text" 
                    id="sellCallOpenQuote" 
                    name="sellCallOpenQuote"
                    value={formData.sellCallOpenQuote} 
                    //value = {parseFloat(formData.sellCallOpenCost) / parseInt(formData.contracts) / 100}
                    onChange={handleChange} 
                    readOnly
                  />
                  <strong><label htmlFor="sellCallOpenCost">Cost:</label></strong>
                  <input 
                    type="text" 
                    id="sellCallOpenCost" 
                    name="sellCallOpenCost"
                    value={formData.sellCallOpenCost} 
                    onChange={handleChange} 
                  />
                  
                </div>
              </div>
            </div>
            <div className="form-row"> 
              <div className="form-group">   
                <div className="form-field-container">  
                  <strong><label htmlFor="sellPutStrike">Sell Put Strike:</label></strong>
                  <input 
                    type="text" 
                    id="sellPutStrike" 
                    name="sellPutStrike"
                    value={formData.sellPutStrike} 
                    onChange={handleChange} 
                  />
                  <strong><label htmlFor="sellPutOpenQuote">Quote:</label></strong>
                  <input 
                    type="text" 
                    id="sellPutOpenQuote" 
                    name="sellPutOpenQuote"
                    //value={parseFloat(formData.sellPutOpenCost) / parseInt(formData.contracts) / 100} 
                    value={formData.sellPutOpenQuote}
                    onChange={handleChange} 
                    readOnly
                  />
                  <strong><label htmlFor="sellPutOpenCost">Cost:</label></strong>
                  <input 
                    type="text" 
                    id="sellPutOpenCost" 
                    name="sellPutOpenCost"
                    value={formData.sellPutOpenCost} 
                    onChange={handleChange} 
                  />
                  
                </div>
              </div>
            </div> 
            <div className="form-row"> 
              <div className="form-group">  
                <div className="form-field-container">
                  <strong><label htmlFor="buyPutStrike">Buy Put Strike:</label></strong>
                  <input 
                    type="text" 
                    id="buyPutStrike" 
                    name="buyPutStrike"
                    value={formData.buyPutStrike} 
                    onChange={handleChange} 
                  />
                  <strong><label htmlFor="buyPutOpenQuote">Quote:</label></strong>
                  <input 
                    type="text" 
                    id="buyPutOpenQuote" 
                    name="buyPutOpenQuote"
                    //value={parseFloat(formData.buyPutOpenCost) / parseInt(formData.contracts) / 100} 
                    value={formData.buyPutOpenQuote}
                    onChange={handleChange} 
                    readOnly
                  />
                  <strong><label htmlFor="buyPutOpenCost">Cost:</label></strong>
                  <input 
                    type="text" 
                    id="buyPutOpenCost" 
                    name="buyPutOpenCost"
                    value={formData.buyPutOpenCost} 
                    onChange={handleChange} 
                  />

                </div>
              </div>
            </div>
              </>
            )}
          </div>
        </div>

        {/* Open Trade Summary Panel */}
        <div className="landing-panel" style={{ marginBottom: '24px' }}>
          <div className="landing-panel-header">
            <h2 className="landing-panel-title">📊 Open Trade Summary</h2>
          </div>
          <div className="landing-panel-content">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: '16px' }}>
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  Last Sale Open:
                </label>
                <input
                  type="text"
                  id="lastSale"
                  name="lastSale"
                  value={formData.lastSale}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />
              </div>
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  Net Amount Open:
                </label>
                <input
                  type="text"
                  id="netAmount"
                  name="netAmount"
                  value={formData.netAmount}
                  onChange={handleChange}
                  readOnly
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: 'rgba(243, 244, 246, 1)'
                  }}
                />
              </div>
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  Open Cost:
                </label>
                <input
                  type="text"
                  id="openCost"
                  name="openCost"
                  value={formData.openCost}
                  onChange={handleChange}
                  readOnly
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: 'rgba(243, 244, 246, 1)'
                  }}
                />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '16px' }}>
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  Max Gain:
                </label>
                <input
                  type="text"
                  id="maxGain"
                  name="maxGain"
                  value={formData.maxGain}
                  onChange={handleChange}
                  readOnly
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: 'rgba(243, 244, 246, 1)'
                  }}
                />
              </div>
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  VIX Last Sale:
                </label>
                <input
                  type="text"
                  id="vixLastSale"
                  name="vixLastSale"
                  value={formData.vixLastSale}
                  onChange={handleChange}
                  readOnly
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: 'rgba(243, 244, 246, 1)'
                  }}
                />
              </div>
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  VIX Change %:
                </label>
                <input
                  type="text"
                  id="vixChange"
                  name="vixChange"
                  value={formData.vixChange}
                  onChange={handleChange}
                  readOnly
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: 'rgba(243, 244, 246, 1)'
                  }}
                />
              </div>
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  MKT Direction:
                </label>
                <input
                  type="text"
                  id="mktDirection"
                  name="mktDirection"
                  value={formData.mktDirection}
                  onChange={handleChange}
                  readOnly
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: 'rgba(243, 244, 246, 1)'
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Open Trade Greeks Panel */}
        <div className="landing-panel" style={{ marginBottom: '24px' }}>
          <div className="landing-panel-header">
            <h2 className="landing-panel-title">📊 Open Trade Greeks</h2>
          </div>
          <div className="landing-panel-content">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '16px' }}>
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  Net Vega:
                </label>
                <input
                  type="text"
                  id="netVega"
                  name="netVega"
                  value={formData.netVega}
                  onChange={handleChange}
                  readOnly
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: 'rgba(243, 244, 246, 1)'
                  }}
                />
              </div>
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  Net Delta:
                </label>
                <input
                  type="text"
                  id="netDelta"
                  name="netDelta"
                  value={formData.netDelta}
                  onChange={handleChange}
                  readOnly
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: 'rgba(243, 244, 246, 1)'
                  }}
                />
              </div>
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  Net Gamma:
                </label>
                <input
                  type="text"
                  id="netGamma"
                  name="netGamma"
                  value={formData.netGamma}
                  onChange={handleChange}
                  readOnly
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: 'rgba(243, 244, 246, 1)'
                  }}
                />
              </div>
              <div>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)', display: 'block', marginBottom: '8px' }}>
                  Net Theta:
                </label>
                <input
                  type="text"
                  id="netTheta"
                  name="netTheta"
                  value={formData.netTheta}
                  onChange={handleChange}
                  readOnly
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: 'rgba(243, 244, 246, 1)'
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Close Trade Panel */}
        <div className="landing-panel" style={{ marginBottom: '24px' }}>
          <div className="landing-panel-header">
            <h2 className="landing-panel-title">📉 Close Trade</h2>
          </div>
          <div className="landing-panel-content">
            {/* Close Trade Strikes */}
            <div style={{ marginBottom: '24px' }}>
              <h3 style={{
                fontSize: '16px',
                fontWeight: '600',
                color: 'rgba(0, 0, 0, 0.9)',
                marginBottom: '16px'
              }}>
                Close Trade Strikes
              </h3>

              {record.position === "LONG" ? (
                <>
                  {/* Buy Call Strike - Green background */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: '180px 1fr 100px 1fr 100px 1fr 140px',
                    gap: '12px',
                    padding: '12px',
                    background: 'rgba(240, 253, 244, 1)',
                    borderRadius: '8px',
                    marginBottom: '12px',
                    alignItems: 'center'
                  }}>
                    <label style={{ fontWeight: '600' }}>Buy Call Strike:</label>
                    <input
                      type="text"
                      id="sellCallStrike"
                      name="sellCallStrike"
                      value={formData.sellCallStrike}
                      onChange={handleChange}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '600' }}>Quote:</label>
                    <input
                      type="text"
                      id="buyCallCloseQuote"
                      name="buyCallCloseQuote"
                      value={formData.buyCallCloseQuote}
                      onChange={handleChange}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '600' }}>Cost:</label>
                    <input
                      type="text"
                      id="buyCallCloseCost"
                      name="buyCallCloseCost"
                      value={formData.buyCallCloseCost}
                      onChange={handleChange}
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px'
                      }}
                    />
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600' }}>
                      <input
                        type="checkbox"
                        id="buyCallStrikeUpdate"
                        name="buyCallStrikeUpdate"
                        checked={formData.buyCallStrikeUpdate}
                        onChange={handleChange}
                        style={{ width: '18px', height: '18px' }}
                      />
                      Stop Update
                    </label>
                  </div>

                  {/* Sell Call Strike - Red background */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: '180px 1fr 100px 1fr 100px 1fr 140px',
                    gap: '12px',
                    padding: '12px',
                    background: 'rgba(254, 242, 242, 1)',
                    borderRadius: '8px',
                    marginBottom: '12px',
                    alignItems: 'center'
                  }}>
                    <label style={{ fontWeight: '600' }}>Sell Call Strike:</label>
                    <input
                      type="text"
                      id="buyCallStrike"
                      name="buyCallStrike"
                      value={formData.buyCallStrike}
                      onChange={handleChange}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '600' }}>Quote:</label>
                    <input
                      type="text"
                      id="sellCallCloseQuote"
                      name="sellCallCloseQuote"
                      value={formData.sellCallCloseQuote}
                      onChange={handleChange}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '600' }}>Cost:</label>
                    <input
                      type="text"
                      id="sellCallCloseCost"
                      name="sellCallCloseCost"
                      value={formData.sellCallCloseCost}
                      onChange={handleChange}
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px'
                      }}
                    />
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600' }}>
                      <input
                        type="checkbox"
                        id="sellCallStrikeUpdate"
                        name="sellCallStrikeUpdate"
                        checked={formData.sellCallStrikeUpdate}
                        onChange={handleChange}
                        style={{ width: '18px', height: '18px' }}
                      />
                      Stop Update
                    </label>
                  </div>

                  {/* Sell Put Strike - Red background */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: '180px 1fr 100px 1fr 100px 1fr 140px',
                    gap: '12px',
                    padding: '12px',
                    background: 'rgba(254, 242, 242, 1)',
                    borderRadius: '8px',
                    marginBottom: '12px',
                    alignItems: 'center'
                  }}>
                    <label style={{ fontWeight: '600' }}>Sell Put Strike:</label>
                    <input
                      type="text"
                      id="buyPutStrike"
                      name="buyPutStrike"
                      value={formData.buyPutStrike}
                      onChange={handleChange}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '600' }}>Quote:</label>
                    <input
                      type="text"
                      id="sellPutCloseQuote"
                      name="sellPutCloseQuote"
                      value={formData.sellPutCloseQuote}
                      onChange={handleChange}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '600' }}>Cost:</label>
                    <input
                      type="text"
                      id="sellPutCloseCost"
                      name="sellPutCloseCost"
                      value={formData.sellPutCloseCost}
                      onChange={handleChange}
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px'
                      }}
                    />
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600' }}>
                      <input
                        type="checkbox"
                        id="sellPutStrikeUpdate"
                        name="sellPutStrikeUpdate"
                        checked={formData.sellPutStrikeUpdate}
                        onChange={handleChange}
                        style={{ width: '18px', height: '18px' }}
                      />
                      Stop Update
                    </label>
                  </div>

                  {/* Buy Put Strike - Green background */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: '180px 1fr 100px 1fr 100px 1fr 140px',
                    gap: '12px',
                    padding: '12px',
                    background: 'rgba(240, 253, 244, 1)',
                    borderRadius: '8px',
                    alignItems: 'center'
                  }}>
                    <label style={{ fontWeight: '600' }}>Buy Put Strike:</label>
                    <input
                      type="text"
                      id="sellPutStrike"
                      name="sellPutStrike"
                      value={formData.sellPutStrike}
                      onChange={handleChange}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '600' }}>Quote:</label>
                    <input
                      type="text"
                      id="buyPutCloseQuote"
                      name="buyPutCloseQuote"
                      value={formData.buyPutCloseQuote}
                      onChange={handleChange}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '600' }}>Cost:</label>
                    <input
                      type="text"
                      id="buyPutCloseCost"
                      name="buyPutCloseCost"
                      value={formData.buyPutCloseCost}
                      onChange={handleChange}
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px'
                      }}
                    />
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600' }}>
                      <input
                        type="checkbox"
                        id="buyPutStrikeUpdate"
                        name="buyPutStrikeUpdate"
                        checked={formData.buyPutStrikeUpdate}
                        onChange={handleChange}
                        style={{ width: '18px', height: '18px' }}
                      />
                      Stop Update
                    </label>
                  </div>
                </>
              ) : (
                <>
                  {/* Sell Call Strike - Red background (SHORT position) */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: '180px 1fr 100px 1fr 100px 1fr 140px',
                    gap: '12px',
                    padding: '12px',
                    background: 'rgba(254, 242, 242, 1)',
                    borderRadius: '8px',
                    marginBottom: '12px',
                    alignItems: 'center'
                  }}>
                    <label style={{ fontWeight: '600' }}>Sell Call Strike:</label>
                    <input
                      type="text"
                      id="buyCallStrike"
                      name="buyCallStrike"
                      value={formData.buyCallStrike}
                      onChange={handleChange}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '600' }}>Quote:</label>
                    <input
                      type="text"
                      id="sellCallCloseQuote"
                      name="sellCallCloseQuote"
                      value={formData.sellCallCloseQuote}
                      onChange={handleChange}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '600' }}>Cost:</label>
                    <input
                      type="text"
                      id="sellCallCloseCost"
                      name="sellCallCloseCost"
                      value={formData.sellCallCloseCost}
                      onChange={handleChange}
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px'
                      }}
                    />
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600' }}>
                      <input
                        type="checkbox"
                        id="sellCallStrikeUpdate"
                        name="sellCallStrikeUpdate"
                        checked={formData.sellCallStrikeUpdate}
                        onChange={handleChange}
                        style={{ width: '18px', height: '18px' }}
                      />
                      Stop Update
                    </label>
                  </div>

                  {/* Buy Call Strike - Green background (SHORT position) */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: '180px 1fr 100px 1fr 100px 1fr 140px',
                    gap: '12px',
                    padding: '12px',
                    background: 'rgba(240, 253, 244, 1)',
                    borderRadius: '8px',
                    marginBottom: '12px',
                    alignItems: 'center'
                  }}>
                    <label style={{ fontWeight: '600' }}>Buy Call Strike:</label>
                    <input
                      type="text"
                      id="sellCallStrike"
                      name="sellCallStrike"
                      value={formData.sellCallStrike}
                      onChange={handleChange}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '600' }}>Quote:</label>
                    <input
                      type="text"
                      id="buyCallCloseQuote"
                      name="buyCallCloseQuote"
                      value={formData.buyCallCloseQuote}
                      onChange={handleChange}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '600' }}>Cost:</label>
                    <input
                      type="text"
                      id="buyCallCloseCost"
                      name="buyCallCloseCost"
                      value={formData.buyCallCloseCost}
                      onChange={handleChange}
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px'
                      }}
                    />
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600' }}>
                      <input
                        type="checkbox"
                        id="buyCallStrikeUpdate"
                        name="buyCallStrikeUpdate"
                        checked={formData.buyCallStrikeUpdate}
                        onChange={handleChange}
                        style={{ width: '18px', height: '18px' }}
                      />
                      Stop Update
                    </label>
                  </div>

                  {/* Buy Put Strike - Green background (SHORT position) */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: '180px 1fr 100px 1fr 100px 1fr 140px',
                    gap: '12px',
                    padding: '12px',
                    background: 'rgba(240, 253, 244, 1)',
                    borderRadius: '8px',
                    marginBottom: '12px',
                    alignItems: 'center'
                  }}>
                    <label style={{ fontWeight: '600' }}>Buy Put Strike:</label>
                    <input
                      type="text"
                      id="sellPutStrike"
                      name="sellPutStrike"
                      value={formData.sellPutStrike}
                      onChange={handleChange}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '600' }}>Quote:</label>
                    <input
                      type="text"
                      id="buyPutCloseQuote"
                      name="buyPutCloseQuote"
                      value={formData.buyPutCloseQuote}
                      onChange={handleChange}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '600' }}>Cost:</label>
                    <input
                      type="text"
                      id="buyPutCloseCost"
                      name="buyPutCloseCost"
                      value={formData.buyPutCloseCost}
                      onChange={handleChange}
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px'
                      }}
                    />
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600' }}>
                      <input
                        type="checkbox"
                        id="buyPutStrikeUpdate"
                        name="buyPutStrikeUpdate"
                        checked={formData.buyPutStrikeUpdate}
                        onChange={handleChange}
                        style={{ width: '18px', height: '18px' }}
                      />
                      Stop Update
                    </label>
                  </div>

                  {/* Sell Put Strike - Red background (SHORT position) */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: '180px 1fr 100px 1fr 100px 1fr 140px',
                    gap: '12px',
                    padding: '12px',
                    background: 'rgba(254, 242, 242, 1)',
                    borderRadius: '8px',
                    alignItems: 'center'
                  }}>
                    <label style={{ fontWeight: '600' }}>Sell Put Strike:</label>
                    <input
                      type="text"
                      id="buyPutStrike"
                      name="buyPutStrike"
                      value={formData.buyPutStrike}
                      onChange={handleChange}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '600' }}>Quote:</label>
                    <input
                      type="text"
                      id="sellPutCloseQuote"
                      name="sellPutCloseQuote"
                      value={formData.sellPutCloseQuote}
                      onChange={handleChange}
                      readOnly
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px',
                        background: 'rgba(243, 244, 246, 1)'
                      }}
                    />
                    <label style={{ fontWeight: '600' }}>Cost:</label>
                    <input
                      type="text"
                      id="sellPutCloseCost"
                      name="sellPutCloseCost"
                      value={formData.sellPutCloseCost}
                      onChange={handleChange}
                      style={{
                        padding: '8px 12px',
                        border: '1px solid rgba(209, 213, 219, 1)',
                        borderRadius: '6px',
                        fontSize: '14px'
                      }}
                    />
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600' }}>
                      <input
                        type="checkbox"
                        id="sellPutStrikeUpdate"
                        name="sellPutStrikeUpdate"
                        checked={formData.sellPutStrikeUpdate}
                        onChange={handleChange}
                        style={{ width: '18px', height: '18px' }}
                      />
                      Stop Update
                    </label>
                  </div>
                </>
              )}
            </div>

            {/* Close Trade Summary */}
            <div style={{ marginBottom: '24px' }}>
              <h3 style={{
                fontSize: '16px',
                fontWeight: '600',
                color: 'rgba(0, 0, 0, 0.9)',
                marginBottom: '16px'
              }}>
                Close Trade Summary
              </h3>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: 'rgba(0, 0, 0, 0.7)',
                    marginBottom: '6px'
                  }}>
                    Close Trade Date
                  </label>
                  <DatePicker
                    selected={selectedCloseTradeDate}
                    onChange={handleChangeCloseDate}
                    dateFormat="yyyy-MM-dd"
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px'
                    }}
                  />
                </div>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: 'rgba(0, 0, 0, 0.7)',
                    marginBottom: '6px'
                  }}>
                    Last Sale Close
                  </label>
                  <input
                    type="text"
                    id="lastSaleClose"
                    name="lastSaleClose"
                    value={formData.lastSaleClose}
                    onChange={handleChange}
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px'
                    }}
                  />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: 'rgba(0, 0, 0, 0.7)',
                    marginBottom: '6px'
                  }}>
                    Net Amount Close
                  </label>
                  <input
                    type="text"
                    id="netAmountClose"
                    name="netAmountClose"
                    value={formData.netAmountClose}
                    onChange={handleChange}
                    readOnly
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px',
                      background: 'rgba(243, 244, 246, 1)'
                    }}
                  />
                </div>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: 'rgba(0, 0, 0, 0.7)',
                    marginBottom: '6px'
                  }}>
                    Close Cost + Fee
                  </label>
                  <input
                    type="text"
                    id="openCost"
                    name="openCost"
                    value={formData.closeCost}
                    onChange={handleChange}
                    readOnly
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px',
                      background: 'rgba(243, 244, 246, 1)'
                    }}
                  />
                </div>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: 'rgba(0, 0, 0, 0.7)',
                    marginBottom: '6px'
                  }}>
                    Desired Profit %
                  </label>
                  <input
                    type="text"
                    id="desiredProfitPercent"
                    name="desiredProfitPercent"
                    value={formData.desiredProfitPercent}
                    onChange={handleChange}
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px'
                    }}
                  />
                </div>
              </div>

              <div style={{ marginTop: '16px' }}>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: 'rgba(0, 0, 0, 0.7)',
                  marginBottom: '6px'
                }}>
                  Desired Net Amount
                </label>
                <input
                  type="text"
                  id="desiredNetAmount"
                  name="desiredNetAmount"
                  value={formData.desiredNetAmount}
                  onChange={handleChange}
                  readOnly
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: 'rgba(243, 244, 246, 1)'
                  }}
                />
              </div>
            </div>

            {/* Close Trade Greeks */}
            <div style={{ marginBottom: '24px' }}>
              <h3 style={{
                fontSize: '16px',
                fontWeight: '600',
                color: 'rgba(0, 0, 0, 0.9)',
                marginBottom: '16px'
              }}>
                Close Trade Greeks
              </h3>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '16px' }}>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: 'rgba(0, 0, 0, 0.7)',
                    marginBottom: '6px'
                  }}>
                    Net Vega Close
                  </label>
                  <input
                    type="text"
                    id="netVegaCurrent"
                    name="netVegaCurrent"
                    value={formData.netVegaCurrent}
                    onChange={handleChange}
                    readOnly
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px',
                      background: 'rgba(243, 244, 246, 1)'
                    }}
                  />
                </div>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: 'rgba(0, 0, 0, 0.7)',
                    marginBottom: '6px'
                  }}>
                    Net Delta Close
                  </label>
                  <input
                    type="text"
                    id="netDeltaCurrent"
                    name="netDeltaCurrent"
                    value={formData.netDeltaCurrent}
                    onChange={handleChange}
                    readOnly
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px',
                      background: 'rgba(243, 244, 246, 1)'
                    }}
                  />
                </div>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: 'rgba(0, 0, 0, 0.7)',
                    marginBottom: '6px'
                  }}>
                    Net Gamma Close
                  </label>
                  <input
                    type="text"
                    id="netGammaCurrent"
                    name="netGammaCurrent"
                    value={formData.netGammaCurrent}
                    onChange={handleChange}
                    readOnly
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px',
                      background: 'rgba(243, 244, 246, 1)'
                    }}
                  />
                </div>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: 'rgba(0, 0, 0, 0.7)',
                    marginBottom: '6px'
                  }}>
                    Net Theta Close
                  </label>
                  <input
                    type="text"
                    id="netThetaCurrent"
                    name="netThetaCurrent"
                    value={formData.netThetaCurrent}
                    onChange={handleChange}
                    readOnly
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      border: '1px solid rgba(209, 213, 219, 1)',
                      borderRadius: '6px',
                      fontSize: '14px',
                      background: 'rgba(243, 244, 246, 1)'
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Profit / Loss Panel */}
        <div className="landing-panel" style={{ marginBottom: '24px' }}>
          <div className="landing-panel-header">
            <h2 className="landing-panel-title">💰 Profit / Loss</h2>
          </div>
          <div className="landing-panel-content">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: 'rgba(0, 0, 0, 0.7)',
                  marginBottom: '6px'
                }}>
                  Profit / Loss Dollars
                </label>
                <input
                  type="text"
                  id="profitLossDollars"
                  name="profitLossDollars"
                  value={formData.profitLossDollars}
                  onChange={handleChange}
                  readOnly
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: 'rgba(243, 244, 246, 1)'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: 'rgba(0, 0, 0, 0.7)',
                  marginBottom: '6px'
                }}>
                  Profit / Loss Percent
                </label>
                <input
                  type="text"
                  id="profitLossPercent"
                  name="profitLossPercent"
                  value={formData.profitLossPercent}
                  onChange={handleChange}
                  readOnly
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: 'rgba(243, 244, 246, 1)'
                  }}
                />
              </div>
            </div>

            <div>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '600',
                color: 'rgba(0, 0, 0, 0.7)',
                marginBottom: '6px'
              }}>
                Notes
              </label>
              <textarea
                id="notes"
                name="notes"
                value={formData.notes}
                onChange={handleChange}
                maxLength="500"
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '1px solid rgba(209, 213, 219, 1)',
                  borderRadius: '6px',
                  fontSize: '14px',
                  minHeight: '100px',
                  resize: 'vertical'
                }}
              />
            </div>
          </div>
        </div>

        {/* Form Buttons */}
        <input type="hidden" name="id" value={formData.id} />
        <div className="form-row-buttons"> 
          <div style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'center',
            marginTop: '24px'
          }}>
            <button
              onClick={() => { handleEditSubmit(); }}
              style={{
                padding: '12px 32px',
                background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Submit
            </button>
            <button
              onClick={() => { handleEditReset(); }}
              style={{
                padding: '12px 32px',
                background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(107, 114, 128, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Reset
            </button>
            <button
              onClick={() => { handleEditBack(); }}
              style={{
                padding: '12px 32px',
                background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(139, 92, 246, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Back
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

const handleEditClick = (record) => {
  selectedRecord.current = record;
  setIsEditing(true);
};

function onFirstDataRendered(params) {
  console.log ("Executing onFirstDataRendered");
  console.log("onFirstDataRendered : params = ", params);
  //params.api.sizeColumnsToFit();
  var allColumnIds = [];
  params.api.getAllDisplayedColumns().forEach(function(column) {
      allColumnIds.push(column.colId);
  });
  params.api.autoSizeColumns(allColumnIds);
}

  function onBtExport () {
    console.log ("Executing onBtExport");
    gridRef.current.api.exportDataAsCsv();;
  };


  function isExpired(expiration) {
    console.log("Executing isExpired");

    const today = new Date();
  
    // Ensure all dates are compared at the start of the day for accuracy
    today.setHours(0, 0, 0, 0); 
  
    // Parse the expiration date string into a Date object
    console.log("isExpired : received expiration = " + expiration);
    //const expirationDate = new Date(expiration);
    const localDateTimeString = expiration + 'T00:00:00'; // Assume midnight
    const expirationDate = new Date(localDateTimeString);
    expirationDate.setHours(0, 0, 0, 0);
  
    // Check if expiration date is greater than today
    const isFutureDate = expirationDate >= today;
    console.log("isExpired : isFutureDate = " + isFutureDate);
    console.log("isExpired : expirationDate = " + expirationDate);
    console.log("isExpired : today = " + today);
  
    if (isFutureDate) {
      return false;
    } else {
      return true;
    }
  }

  function dateTimeNow() {
    asOfDateTime.current = new Date();
    return asOfDateTime.current.toLocaleString();
  }


  const [gridApiNew, setGridApiNew] = useState(null);

  const onGridReady = (params) => {
    setGridApiNew(params.api);
  };

  const applyLiveTradeFilter = () => {
    if (!gridApiNew) return;
    gridApiNew.onFilterChanged();
  };

  const isLiveTrade = (data) => {
    return !isExpired(data.exp) || data.closeTradeDate.toString().length === 0;
  };

  const onFilterChanged = () => {
    console.log ("onFilterChanged : gridApiNew = ", gridApiNew);
    gridApiNew.forEachNode(function(node) {
      node.setRowVisible(isLiveTrade(node.data));
    });
  };

// <button onClick={applyLiveTradeFilter}>Show Live Trades</button>

  return (
    <AppLayout signOut={signOut}>
      <div style={{ maxWidth: '1600px', margin: '0 auto', padding: '24px' }}>
        {!isEditing ? (
          <>
            {/* Page Title */}
            <div style={{ marginBottom: '24px' }}>
              <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)' }}>
                Iron Condor Portfolio
              </h1>
            </div>

            {/* As Of Time */}
            <div style={{
              marginBottom: '16px',
              textAlign: 'right',
              fontSize: '14px',
              color: 'rgba(107, 114, 128, 1)',
              fontWeight: '500'
            }}>
              As Of {dateTimeNow()}
            </div>

            {/* Error Message */}
            {displayMainMessage && (
              <div className="blink_me_red" style={{
                marginBottom: '16px',
                textAlign: 'center',
                fontSize: '16px',
                padding: '12px'
              }}>
                {displayMainMessage}
              </div>
            )}

            {/* Summary Cards */}
            <div style={{ display: 'flex', gap: '16px', marginBottom: '24px' }}>
              <div style={{
                flex: '1',
                background: 'rgba(255, 255, 255, 0.95)',
                border: '1px solid rgba(229, 231, 235, 1)',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  fontSize: '14px',
                  color: 'rgba(107, 114, 128, 1)',
                  marginBottom: '8px',
                  fontWeight: '600'
                }}>
                  Unrealized Profit
                </div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: parseFloat(unrealizedProfit.current) <= 0 ? '#ef4444' : '#10b981'
                }}>
                  {formatCurrency(unrealizedProfit.current)}
                </div>
              </div>

              <div style={{
                flex: '1',
                background: 'rgba(255, 255, 255, 0.95)',
                border: '1px solid rgba(229, 231, 235, 1)',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  fontSize: '14px',
                  color: 'rgba(107, 114, 128, 1)',
                  marginBottom: '8px',
                  fontWeight: '600'
                }}>
                  Realized Profit
                </div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: parseFloat(realizedProfit.current) <= 0 ? '#ef4444' : '#10b981'
                }}>
                  {formatCurrency(realizedProfit.current)}
                </div>
              </div>

              <div style={{
                flex: '1',
                background: 'rgba(255, 255, 255, 0.95)',
                border: '1px solid rgba(229, 231, 235, 1)',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  fontSize: '14px',
                  color: 'rgba(107, 114, 128, 1)',
                  marginBottom: '8px',
                  fontWeight: '600'
                }}>
                  Invested in Market
                </div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: 'rgba(0, 0, 0, 0.9)'
                }}>
                  {formatCurrency(investedInMarket.current)}
                </div>
              </div>
            </div>

            {/* Grid */}
            <div className="ag-theme-quartz" style={{
              height: 'calc(100vh - 480px)',
              minHeight: '400px',
              width: '100%',
              '--ag-header-height': '48px',
              '--ag-row-height': '52px',
              '--ag-header-background-color': 'rgba(249, 250, 251, 1)',
              '--ag-odd-row-background-color': 'rgba(255, 255, 255, 1)',
              '--ag-header-foreground-color': 'rgba(17, 24, 39, 1)',
              '--ag-border-color': 'rgba(229, 231, 235, 1)',
              '--ag-row-hover-color': 'rgba(243, 244, 246, 1)',
              '--ag-selected-row-background-color': 'rgba(219, 234, 254, 1)'
            }}>
              <AgGridReact
                rowClassRules={rowClassRules}
                rowData={rowDataState}
                columnDefs={columns}
                suppressRowClickSelection={true}
                rowSelection={'multiple'}
                ref={gridRef}
                onGridReady={onGridReady}
                onFilterChanged={onFilterChanged}
                onFirstDataRendered={onFirstDataRendered}
                onSelectionChanged={onSelectionChanged}
              />
            </div>

            {/* Action Buttons */}
            <div style={{
              display: 'flex',
              gap: '12px',
              justifyContent: 'center',
              marginTop: '24px'
            }}>
              <button
                onClick={() => { addEmptyRow(); }}
                style={{
                  padding: '12px 32px',
                  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                Add New Option Trade
              </button>
              <button
                onClick={() => { commitChanges(); }}
                style={{
                  padding: '12px 32px',
                  background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(239, 68, 68, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                Delete Selected Row(s)
              </button>
            </div>
          </>
        ) : (
          <EditForm
            record={selectedRecord.current}
            //onSubmit={handleEditSubmit()}
            //onReset={handleEditReset()}
          />
        )
        }
      </div>
    </AppLayout>
  );
};

export default withAuthenticator(MyPortfolioIronCondor);